// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page {
  min-height: 100vh;
  background: var(--bg-primary, #f4f7f7);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}

.settings-main {
  min-width: 0;
}
.settings-content {
  padding: 24px 32px 40px;
}
.settings-content > h1 {
  margin: 0 0 8px;
  font-size: 32px;
  line-height: 40px;
  font-weight: 600;
  letter-spacing: -0.48px;
}
.settings-tabs {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  margin-bottom: 24px;
}
.settings-tabs button {
  position: relative;
  border: 0;
  background: transparent;
  color: var(--text-secondary, #506360);
  padding: 10px 16px;
  white-space: nowrap;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-style: normal;
  font-weight: var(--font-weight-medium, 500);
  line-height: 16.9px;
  letter-spacing: 0.065px;
  cursor: pointer;
}
.settings-tabs button.active {
  color: var(--interactive-default, #0f766e);
}
.settings-tabs button.active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 2px;
  background: var(--interactive-default, #0f766e);
}
.settings-section-heading {
  margin-bottom: 16px;
}
.settings-section-heading h2,
.settings-card h3 {
  margin: 0;
  font-weight: 500;
}
.settings-section-heading h2 {
  font-size: 28px;
  line-height: 36.4px;
  font-weight: 600;
  letter-spacing: -0.28px;
}
.settings-section-heading p,
.settings-card p {
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 21.7px;
}
.settings-section-heading p {
  font-size: 16px;
  line-height: 25.6px;
  letter-spacing: 0;
}
.settings-section-heading p {
  margin: 2px 0 0;
}
.settings-card {
  background: var(--surface-primary, #fff);
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  padding: 24px;
  margin-bottom: 16px;
}
.settings-card h3 {
  font-size: 16px;
  line-height: 20.8px;
  letter-spacing: 0;
}
.settings-photo-row,
.settings-security-card,
.settings-team-links,
.settings-heading-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.settings-photo-row {
  justify-content: flex-start;
  margin-top: 14px;
}
.settings-photo-row img,
.settings-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--border-subtle, #dce3e2);
}
.settings-avatar {
  display: grid;
  place-items: center;
  color: var(--interactive-default, #0f766e);
  background: var(--interactive-soft, #f0f8f7);
  font-weight: 600;
}
.settings-photo-row p {
  margin: 0 0 10px;
}
.settings-button {
  display: inline-flex;
  width: auto;
  height: 44px;
  min-height: 44px;
  box-sizing: border-box;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: var(--radius-md, 10px);
  padding: 0 16px;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  text-decoration: none;
  font-size: 14px;
  font-weight: var(--font-weight-medium, 500);
  line-height: normal;
  letter-spacing: 0;
  white-space: nowrap;
  cursor: pointer;
}
.settings-button.primary {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
}
.settings-button.secondary {
  border: 1px solid var(--border-default, #cdd6d4);
  color: var(--text-primary, #142624);
  background: var(--surface-primary, #fff);
}
.settings-button svg,
.plan-billing-button svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}
.settings-button.primary:hover:not(:disabled) {
  border-color: var(--interactive-hover, var(--interactive-default, #0f766e));
  background: var(--interactive-hover, var(--interactive-default, #0f766e));
}
.settings-button.secondary:hover:not(:disabled) {
  border-color: var(--border-strong, #aebab8);
  background: var(--surface-secondary, #f4f7f7);
}
.settings-button:focus-visible,
.plan-billing-button:focus-visible,
.plan-billing-back:focus-visible,
.plan-navigation-grid button:focus-visible,
.plan-usage-grid button:focus-visible,
.available-plan-heading button:focus-visible,
.plan-history-table button:focus-visible,
.plan-cancel-link:focus-visible {
  outline: 2px solid var(--focus-ring, #8bcfc7);
  outline-offset: 2px;
}
.settings-button:disabled {
  border-color: var(--border-subtle, #dce3e2);
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-disabled, #8a9896);
  cursor: not-allowed;
}
.settings-photo-card .settings-button {
  width: auto;
  height: 40px;
  min-height: 40px;
  gap: 6px;
  padding: 0 12px;
  font-size: 13px;
}
.settings-card-copy {
  margin: 12px 0 16px;
}
.settings-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 20px;
}
.settings-detail-grid.bordered {
  margin-top: 22px;
  padding-top: 20px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.settings-detail-grid .wide {
  grid-column: 1 / -1;
}
.settings-detail-grid div {
  min-height: 64px;
}
.settings-detail-grid span,
.settings-role-row span,
.settings-business-logo span,
.settings-card > span {
  display: block;
  font-size: 13px;
  font-weight: var(--font-weight-medium, 500);
  line-height: 16.9px;
  letter-spacing: 0.065px;
  margin-bottom: 6px;
}
.settings-detail-grid strong {
  display: block;
  min-height: 42px;
  padding: 11px 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  letter-spacing: 0;
}
.settings-business-card .settings-detail-grid input,
.settings-business-card .settings-detail-grid select {
  width: 100%;
  height: 40px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  outline: 0;
  padding: 0 12px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 14px/18.2px var(--font-family-primary, "Lexend", sans-serif);
}
.settings-business-card .settings-detail-grid input:focus,
.settings-business-card .settings-detail-grid select:focus {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.settings-business-organisation-select .quotation-figma-dropdown-trigger {
  border-radius: var(--radius-md, 10px);
  font-size: 14px;
  line-height: 18.2px;
}
.settings-business-card .settings-detail-grid input[readonly] {
  color: var(--text-disabled, #8a9896);
  background: var(--surface-secondary, #f4f7f7);
}
.settings-business-card .settings-card-actions {
  gap: 10px;
}
.settings-role-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 12px;
}
.settings-role-row p {
  margin: 2px 0;
}
.settings-role-row b {
  align-self: center;
  color: var(--interactive-default, #0f766e);
  background: var(--interactive-soft, #f0f8f7);
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 12px;
}
.settings-card-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
.settings-security-card p {
  margin: 2px 0 0;
}
.settings-password-flow {
  width: 100%;
  max-width: 1120px;
}
.settings-password-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 0;
}
.settings-password-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.settings-password-field > span:first-child {
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: var(--font-weight-medium, 500);
  line-height: normal;
}
.settings-password-field > span:first-child b {
  color: var(--danger-default, #c23a2b);
  font-weight: inherit;
}
.settings-password-input {
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  overflow: hidden;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
}
.settings-password-input:focus-within {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.settings-password-field.error .settings-password-input {
  border-color: var(--danger-default, #c23a2b);
}
.settings-password-input input {
  width: 100%;
  min-width: 0;
  height: 100%;
  padding: 0 44px 0 12px;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-primary, #142624);
  font: 400 14px / normal var(--font-family-primary, "Lexend", sans-serif);
}
.settings-password-input input::placeholder {
  color: var(--text-disabled, #8a9896);
  opacity: 1;
}
.settings-password-input button {
  position: absolute;
  right: 8px;
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 0;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.settings-password-input svg {
  width: 20px;
  height: 20px;
}
.settings-password-field small {
  min-height: 15px;
  color: var(--text-secondary, #506360);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}
.settings-password-field.error small,
.settings-password-form-error {
  color: var(--danger-text, #a3301f);
}
.settings-password-security-copy,
.settings-password-form-error {
  margin: 0 !important;
  font-size: 11px !important;
  line-height: 15.4px !important;
  letter-spacing: 0.11px;
}
.settings-password-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}
.settings-password-actions .settings-button {
  height: 44px;
  min-height: 44px;
  padding: 0 16px;
  font-size: 14px;
}
.settings-password-actions .settings-button:disabled {
  cursor: default;
  opacity: 0.65;
}
.settings-photo-card,
.settings-personal-card,
.settings-security-card {
  max-width: 1120px;
  margin-bottom: 24px;
}
.settings-photo-card h3,
.settings-personal-card h3,
.settings-security-card h3,
.settings-password-card h3 {
  font-size: 22px;
  line-height: 29.7px;
  letter-spacing: -0.22px;
}
.settings-photo-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.settings-profile-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 20px;
}
.settings-profile-fields .wide {
  grid-column: 1 / -1;
}
.settings-profile-fields label {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: var(--font-weight-medium, 500);
  line-height: 16.9px;
  letter-spacing: 0.065px;
}
.settings-profile-fields input {
  width: 100%;
  height: 40px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  outline: 0;
  padding: 0 12px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 14px / 18.2px var(--font-family-primary, "Lexend", sans-serif);
}
.settings-profile-fields input:focus {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.settings-profile-fields input[readonly] {
  background: var(--surface-secondary, #f4f7f7);
}
.settings-profile-fields small {
  color: var(--text-secondary, #506360);
  font-size: 12px;
  font-weight: 400;
  line-height: 15.6px;
}
.settings-profile-message {
  margin: 12px 0 0 !important;
  font-size: 12px !important;
}
.settings-personal-card .settings-card-actions .settings-button,
.settings-security-card > .settings-button,
.settings-password-actions .settings-button {
  min-height: 44px;
}
.settings-photo-dialog-scrim {
  position: fixed;
  z-index: 1700;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  background: var(--overlay-default, rgba(15, 29, 27, 0.48));
}
.settings-photo-dialog {
  width: min(520px, 100%);
  min-height: 447px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  padding: 24px;
  background: var(--surface-primary, #fff);
  box-shadow: var(--shadow-lg, 0 16px 40px rgba(20, 38, 36, 0.2));
}
.settings-photo-dialog header {
  display: flex;
  height: 30px;
  align-items: center;
  justify-content: space-between;
}
.settings-photo-dialog h2 {
  margin: 0;
  color: var(--text-primary, #142624);
  font-size: 22px;
  font-weight: 500;
  line-height: 29.7px;
  letter-spacing: -0.22px;
}
.settings-photo-dialog header button {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 0;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.settings-photo-dialog header button svg {
  width: 20px;
  height: 20px;
}
.settings-photo-dialog header button span {
  display: none;
}
.settings-photo-dialog-body {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}
.settings-photo-dialog-body > p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 21.7px;
}
.settings-photo-dialog-preview {
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  border-radius: var(--radius-md, 10px);
  background: var(--surface-secondary, #f4f7f7);
  text-align: center;
}
.settings-photo-dialog-preview strong {
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
}
.settings-photo-dialog-preview > img {
  width: 104px;
  height: 104px;
  border: 2px solid var(--border-subtle, #dce3e2);
  border-radius: 50%;
  object-fit: cover;
}
.settings-photo-dialog-preview small,
.settings-photo-dialog-note {
  color: var(--text-secondary, #506360);
  font-size: 11px;
  font-weight: 400;
  line-height: 15.4px;
  letter-spacing: 0.11px;
}
.settings-photo-dialog .settings-photo-choose {
  width: 100%;
  min-height: 44px;
  border: 0;
  cursor: pointer;
}
.settings-photo-dialog-error {
  margin: -8px 0 0 !important;
  color: var(--danger-text, #a3301f) !important;
  font-size: 12px !important;
}
.settings-photo-dialog-actions {
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  gap: 12px;
}
.settings-photo-dialog-actions .settings-button {
  min-height: 44px;
  cursor: pointer;
}
.settings-business-logo {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 0;
}
.settings-business-logo em {
  color: var(--text-tertiary, #6b7b78);
  font-style: normal;
  font-weight: 400;
  margin-left: 6px;
}
.settings-business-logo p {
  margin: 4px 0 0;
}
.settings-business-logo-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}
.settings-business-logo i {
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  background: var(--interactive-default, #0f766e);
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
}
.settings-business-logo-controls > img {
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f7);
  object-fit: contain;
}
.settings-business-logo-placeholder {
  display: grid;
  width: 104px;
  height: 104px;
  place-items: center;
  border-radius: 12px;
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
  font-size: 20px;
  font-weight: 600;
}
.settings-business-logo-dialog .settings-photo-dialog-preview > img {
  border-radius: 12px;
  object-fit: contain;
}
.settings-business-logo .settings-logo-action {
  min-width: 106px;
  height: 36px;
  min-height: 36px;
  padding: 0 12px;
  font-size: 13px;
  line-height: 16.9px;
  letter-spacing: 0.065px;
}
.settings-business-logo .settings-logo-action svg,
.settings-business-logo .settings-logo-remove svg {
  width: 16px;
  height: 16px;
}
.settings-business-logo .settings-logo-remove {
  min-width: 104px;
  height: 36px;
  min-height: 36px;
  padding: 0 12px;
  border: 0;
  background: transparent;
  color: var(--danger-text, #a3301f);
  font-size: 13px;
  line-height: 16.9px;
  letter-spacing: 0.065px;
  cursor: pointer;
}
.settings-business-logo .settings-logo-remove:hover {
  background: var(--danger-soft, #fff2ef);
}
.settings-business-logo .settings-logo-remove:disabled {
  cursor: default;
  opacity: 0.55;
}
.settings-business-logo-recommendation {
  margin-top: 8px !important;
  color: var(--text-secondary, #506360);
  font-size: 13px !important;
  line-height: 18.2px !important;
  letter-spacing: 0.065px;
}
.settings-business-skeleton {
  pointer-events: none;
}
.settings-business-skeleton-logo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.settings-business-skeleton-logo > div {
  display: flex;
  align-items: center;
  gap: 8px;
}
.settings-business-skeleton-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 20px;
}
.settings-business-skeleton-grid.bordered {
  padding: 20px 0 0;
}
.settings-business-skeleton-grid > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
}
.settings-business-skeleton-grid > .wide,
.settings-business-skeleton-grid.bordered > div:last-child {
  grid-column: 1 / -1;
}
.settings-business-skeleton-subheading {
  margin: 22px 0 14px;
}
.settings-business-skeleton-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
@media (max-width: 767px) {
  .settings-business-skeleton-grid {
    grid-template-columns: 1fr;
  }
  .settings-business-skeleton-grid > .wide,
  .settings-business-skeleton-grid.bordered > div:last-child {
    grid-column: auto;
  }
  .settings-business-skeleton-logo > .app-skeleton {
    max-width: 100%;
  }
}
.settings-subheading {
  margin: 20px 0 12px !important;
}
.settings-empty {
  min-height: 555px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.settings-empty > span {
  width: 56px;
  height: 56px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: var(--interactive-default, #0f766e);
  background: var(--interactive-soft, #f0f8f7);
  font-size: 30px;
}
.settings-empty h3 {
  margin-top: 14px;
}
.settings-empty p {
  max-width: 440px;
  margin: 4px 0 14px;
}
.settings-plan small {
  color: var(--interactive-default, #0f766e);
  font-weight: 600;
  letter-spacing: 0.8px;
}
.settings-plan h3 {
  margin: 8px 0;
  font-size: 24px;
}
.settings-plan p {
  margin: 12px 0 0;
}
.settings-stat-grid,
.settings-link-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}
.settings-stat-grid.two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.settings-stat-grid .settings-card svg {
  color: var(--interactive-default, #0f766e);
  font-size: 20px;
}
.settings-stat-grid h3 {
  margin-top: 8px;
  font-size: 22px;
}
.settings-link-grid .settings-card {
  min-height: 145px;
  display: flex;
  flex-direction: column;
}
.settings-link-grid p {
  flex: 1 1;
}
.settings-link-grid a,
.settings-team-tabs a {
  color: var(--interactive-default, #0f766e);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
}
.settings-team-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}
.settings-team-tabs a {
  padding: 10px 12px;
  border-bottom: 2px solid var(--interactive-default, #0f766e);
}
.settings-team-links > svg {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  color: var(--interactive-default, #0f766e);
}
.settings-team-links > div {
  flex: 1 1;
}
.settings-team-links p {
  margin: 3px 0 0;
}
.settings-responsive-context {
  display: none;
}
.settings-team-workspace {
  position: relative;
}
.settings-heading-action .settings-button {
  cursor: pointer;
}
.settings-team-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  width: max-content;
}
.settings-team-tabs button {
  position: relative;
  min-height: 40px;
  padding: 0 12px;
  border: 0;
  background: transparent;
  color: var(--text-secondary, #506360);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-style: normal;
  font-weight: var(--font-weight-medium, 500);
  line-height: 16.9px;
  letter-spacing: 0.065px;
  cursor: pointer;
}
.settings-team-tabs button.active {
  color: var(--interactive-default, #0f766e);
}
.settings-team-tabs button.active::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: -1px;
  left: 0;
  height: 2px;
  background: var(--interactive-default, #0f766e);
}
.settings-team-stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}
.settings-team-stats section {
  display: flex;
  min-height: 116px;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
}
.settings-team-stats span,
.settings-team-stats small {
  color: var(--text-secondary, #506360);
}
.settings-team-stats span {
  font-size: 14px;
  line-height: 21.7px;
  letter-spacing: 0;
}
.settings-team-stats small {
  font-size: 12px;
  line-height: 16.8px;
  letter-spacing: 0.12px;
}
.settings-team-stats strong {
  margin: 4px 0 2px;
  font-size: 28px;
  line-height: 36.4px;
  font-weight: 600;
  letter-spacing: -0.28px;
}
.settings-team-stat-skeleton > :is(span, strong, small) {
  display: flex;
  align-items: center;
  min-height: 1lh;
}
.settings-team-stat-skeleton strong > .app-skeleton {
  font: inherit;
  height: 1em;
}
.settings-team-table-card,
.settings-team-form-card {
  margin-bottom: 16px;
  overflow: visible;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
}
.settings-team-table-card > header {
  display: flex;
  min-height: 56px;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}
.settings-team-table-card h3,
.settings-team-form-card h3 {
  margin: 0;
  font-size: 22px;
  line-height: 29.7px;
  font-weight: 500;
  letter-spacing: -0.22px;
}
.settings-team-table-card > header span {
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 21.7px;
  letter-spacing: 0;
}
.settings-team-table-scroll {
  overflow-x: auto;
}
.settings-team-table-card table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.settings-team-table-card th,
.settings-team-table-card td {
  height: 52px;
  padding: 0 20px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
  text-align: left;
  font-size: 14px;
  line-height: 21.7px;
  letter-spacing: 0;
  font-weight: 400;
}
.settings-team-table-card th {
  height: 44px;
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 18.2px;
  font-weight: 500;
  letter-spacing: 0.07px;
}
.settings-team-table-card tbody tr:nth-child(even) {
  background: var(--interactive-soft, #f0f8f7);
}
.settings-member-name {
  display: flex;
  align-items: center;
  gap: 8px;
}
.settings-member-name i,
.settings-member-summary > i {
  display: grid;
  width: 26px;
  height: 26px;
  flex: 0 0 auto;
  place-items: center;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 50%;
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
  font-size: 10px;
  font-style: normal;
}
.settings-status {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 14px;
  line-height: 21.7px;
}
.settings-status.active {
  background: var(--success-soft, #f0fdf4);
  color: var(--success-text, #15803d);
}
.settings-status.pending {
  background: var(--warning-soft, #fef8ec);
  color: var(--warning-text, #7d4412);
}
.settings-status.inactive {
  background: var(--danger-soft, #fef2f2);
  color: var(--danger-text, #b42318);
}
.settings-action-cell {
  position: relative;
  width: 100px;
  text-align: center !important;
}
.settings-action-heading {
  text-align: center !important;
}
.settings-action-cell > button {
  display: inline-grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: inherit;
  cursor: pointer;
}
.settings-action-cell > button:hover {
  background: var(--surface-tertiary, #e8edec);
}
.settings-action-cell > button:focus-visible,
.reminder-row > button:focus-visible,
.settings-tabs button:focus-visible,
.settings-team-tabs button:focus-visible {
  outline: 2px solid var(--focus-ring, #8bcfc7);
  outline-offset: 2px;
}
.settings-action-menu {
  position: absolute;
  z-index: 20;
  top: 42px;
  right: 16px;
  width: 160px;
  padding: 6px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  box-shadow: 0 10px 28px rgba(20, 38, 36, 0.14);
}
.settings-action-menu button {
  width: 100%;
  padding: 9px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-primary, #142624);
  text-align: left;
  font: inherit;
  cursor: pointer;
}
.settings-action-menu button:hover {
  background: var(--surface-secondary, #f4f7f7);
}
.settings-action-menu button.danger {
  color: var(--danger-text, #a3301f);
}
.settings-team-empty-row,
.settings-team-empty-pending {
  color: var(--text-secondary, #506360);
  text-align: center !important;
}
.settings-team-empty-row svg {
  margin-right: 8px;
}
.settings-team-empty-pending {
  display: grid;
  min-height: 170px;
  place-items: center;
  align-content: center;
  gap: 4px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.settings-team-empty-pending svg {
  margin-bottom: 6px;
  font-size: 28px;
  color: var(--interactive-default, #0f766e);
}
.settings-team-empty-pending p {
  margin: 0;
  font-size: 13px;
}
.settings-team-form-card {
  padding: 24px;
}
.settings-team-form-card > h3 {
  margin-bottom: 18px;
}
.settings-team-form-card label {
  display: block;
  font-size: 12px;
  font-weight: 500;
}
.settings-team-form-card label b {
  color: var(--danger-text, #a3301f);
}
.settings-team-form-card input,
.settings-team-form-card select {
  width: 100%;
  height: 42px;
  margin-top: 6px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  outline: none;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 14px/20px inherit;
}
.settings-team-form-card select {
  appearance: none;
  padding-right: 38px;
}
.settings-team-form-card input:focus,
.settings-team-form-card select:focus {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.settings-team-form-card input.error,
.settings-team-form-card select.error {
  border-color: var(--danger-text, #a3301f);
}
.settings-team-form-card label small {
  display: block;
  min-height: 17px;
  margin-top: 4px;
  color: var(--text-secondary, #506360);
  font-weight: 400;
}
.settings-team-form-card input.error + small,
.settings-team-form-card .settings-role-permission-select:has(.error) + small,
.settings-team-form-card .settings-select-wrap:has(select.error) + small {
  color: var(--danger-text, #a3301f);
}
.settings-select-wrap {
  position: relative;
  display: block;
}
.settings-select-wrap > svg {
  position: absolute;
  top: 19px;
  right: 12px;
  pointer-events: none;
}
.settings-team-form-card > p,
.settings-role-access > p {
  color: var(--text-secondary, #506360);
  font-size: 12px;
}
.settings-team-form-card footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.settings-team-form-card footer button {
  cursor: pointer;
}
.settings-member-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding: 14px;
  border-radius: 8px;
  background: var(--surface-secondary, #f4f7f7);
}
.settings-member-summary > i {
  width: 40px;
  height: 40px;
}
.settings-member-summary div {
  display: flex;
  flex-direction: column;
}
.settings-member-summary span {
  color: var(--text-secondary, #506360);
  font-size: 12px;
}
.settings-role-fields,
.settings-access-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 20px;
}
.settings-member-access-fields {
  margin-top: var(--space-4, 16px);
}
.settings-role-access {
  margin-top: 4px;
  padding-top: 18px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.settings-access-grid {
  margin-top: 14px;
}
.settings-role-permission-select {
  margin-top: 0;
}
.settings-role-permission-select .quotation-figma-dropdown-trigger {
  height: 40px;
  padding: 0 12px;
  border-color: var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  font-size: 14px;
}
.settings-module-access-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 20px;
  margin-top: var(--space-4, 16px);
}
.settings-role-form label.settings-module-access-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  margin: 0;
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: 500;
}
.settings-module-access-field .quotation-figma-dropdown-trigger > span {
  color: var(--text-primary, #142624);
  font-weight: 400;
}
.settings-module-access-field .quotation-figma-dropdown-trigger:disabled > span,
.settings-module-access-field .quotation-figma-dropdown-trigger > span:empty {
  color: var(--text-disabled, #8a9896);
}
.settings-role-form-body {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
.settings-role-form-body > h3 {
  margin-bottom: var(--space-4, 16px);
}
.settings-role-form .settings-module-search {
  position: relative;
  display: flex;
  align-items: center;
  max-width: 400px;
  margin: var(--space-4, 16px) 0;
}
.settings-module-search > svg {
  position: absolute;
  left: 12px;
  color: var(--text-secondary);
  pointer-events: none;
}
.settings-role-form .settings-module-search input {
  margin: 0;
  padding: 0 40px;
}
.settings-permission-group {
  margin-top: var(--space-3, 12px);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md, 10px);
}
.settings-permission-group h4 {
  margin: 0;
}
.settings-permission-group h4 button {
  display: flex;
  align-items: center;
  gap: var(--space-3, 12px);
  width: 100%;
  min-height: 48px;
  padding: var(--space-3, 12px) var(--space-4, 16px);
  border: 0;
  border-radius: var(--radius-md, 10px);
  background: var(--surface-secondary);
  color: var(--text-primary);
  font: inherit;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
}
.settings-permission-group h4 button small {
  margin-left: auto;
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 400;
}
.settings-permission-group h4 button svg {
  flex-shrink: 0;
}
.settings-permission-group h4 button[aria-expanded="true"] svg {
  transform: rotate(180deg);
}
.settings-permission-group h4 button:hover:not(:disabled) {
  background: var(--surface-hover, var(--surface-primary));
}
.settings-permission-group h4 button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
.settings-role-form label.settings-module-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 180px;
  align-items: center;
  gap: var(--space-4, 16px);
  margin: 0;
  padding: var(--space-2, 8px) var(--space-4, 16px);
  border-top: 1px solid var(--border-subtle);
  font-size: 14px;
}
.settings-module-row > span {
  overflow-wrap: anywhere;
}
.settings-module-row .settings-role-permission-select {
  min-width: 0;
  margin: 0;
}
.settings-module-empty {
  padding: var(--space-4, 16px);
  background: var(--surface-secondary);
  border-radius: var(--radius-md, 10px);
}
.settings-role-form footer.settings-role-actions {
  position: sticky;
  bottom: 0;
  z-index: 5;
  flex-wrap: wrap;
  margin: var(--space-4, 16px) -24px -24px;
  padding: var(--space-4, 16px) 24px
    max(var(--space-4, 16px), env(safe-area-inset-bottom));
  background: var(--surface-primary);
  border-radius: 0 0 var(--radius-md, 10px) var(--radius-md, 10px);
}
.settings-role-actions .settings-form-alert {
  flex-basis: 100%;
  margin: 0;
}
.settings-role-saving {
  animation: settings-role-spin 1s linear infinite;
}
@keyframes settings-role-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .settings-role-saving {
    animation: none;
  }
}
@media (max-width: 640px) {
  .settings-role-form label.settings-module-row {
    grid-template-columns: minmax(0, 1fr) minmax(130px, 45%);
    gap: var(--space-2, 8px);
    padding: var(--space-2, 8px);
    font-size: 12px;
  }
  .settings-permission-group h4 button {
    padding: var(--space-3, 12px) var(--space-2, 8px);
    gap: var(--space-2, 8px);
  }
}
.settings-form-alert {
  margin-bottom: 14px;
  padding: 10px 12px;
  border-radius: 8px;
  background: var(--danger-soft, #fef2f1);
  color: var(--danger-text, #a3301f);
  font-size: 13px;
}
.settings-member-choice {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.settings-member-choice > button {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  gap: 4px 12px;
  min-height: 116px;
  padding: 18px;
  border: 1px solid var(--border-default, #cad5d3);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  text-align: left;
  cursor: pointer;
}
.settings-member-choice > button:hover,
.settings-member-choice > button:focus-visible {
  border-color: var(--interactive-default, #0f8178);
}
.settings-member-choice > button > svg {
  grid-row: 1 / 3;
  width: 24px;
  height: 24px;
  color: var(--interactive-default, #0f8178);
}
.settings-member-choice > button > span {
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18px;
}
.settings-member-choice > footer {
  grid-column: 1 / -1;
}
.settings-existing-destination {
  margin: 0 0 16px;
  padding: 12px 14px;
  border-radius: 8px;
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-secondary, #506360);
}
.settings-existing-member-loading {
  display: grid;
  gap: 16px;
}
@media (max-width: 640px) {
  .settings-member-choice {
    grid-template-columns: 1fr;
  }
  .settings-member-choice > footer {
    grid-column: auto;
  }
}
.settings-page.dark {
  --bg-primary: #101113;
  --surface-primary: #191b1f;
  --text-primary: #f2f3f5;
  --text-secondary: #b3b8c2;
  --border-default: #3a3f47;
  --border-subtle: #2c3036;
  --border-strong: #555d68;
  --interactive-default: #43a79c;
  --interactive-hover: #56b9ae;
  --interactive-soft: #22252a;
  --on-interactive-primary: #101113;
  --focus-ring: #73c9c0;
  --text-disabled: #747b86;
  --surface-secondary: #22252a;
  --surface-tertiary: #2b2f35;
  --success-soft: #1b332b;
  --success-text: #8cd2b2;
  --warning-soft: #3b2e19;
  --warning-text: #e5c17d;
  --danger-soft: #382324;
  --danger-text: #f3a6a1;
}
@media (max-width: 900px) {
  .settings-content {
    padding: 24px;
  }
  .settings-responsive-context {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 61px;
  }
  .settings-product-identity {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--text-secondary, #506360);
    font-size: 13px;
    font-weight: 500;
    line-height: 16.9px;
  }
  .settings-product-identity button {
    display: grid;
    width: 44px;
    height: 44px;
    place-items: center;
    padding: 0;
    border: 1px solid var(--border-subtle, #dce3e2);
    border-radius: 10px;
    color: var(--text-primary, #142624);
    background: var(--surface-primary, #fff);
    cursor: pointer;
  }
  .settings-product-identity button svg {
    width: 20px;
    height: 20px;
  }
  .settings-organisation-selector {
    display: flex;
    width: 220px;
    min-width: 0;
    align-items: center;
    gap: 8px;
    padding: 12px;
    border: 1px solid var(--border-subtle, #dce3e2);
    border-radius: 10px;
    background: var(--surface-primary, #fff);
  }
  .settings-organisation-selector > i {
    display: grid;
    width: 32px;
    height: 32px;
    flex: 0 0 auto;
    place-items: center;
    border: 1.5px solid var(--border-subtle, #dce3e2);
    border-radius: 50%;
    color: var(--interactive-default, #0f766e);
    background: var(--interactive-soft, #f0f8f7);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
  }
  .settings-organisation-selector > span {
    display: flex;
    min-width: 0;
    flex: 1 1;
    flex-direction: column;
    gap: 4px;
  }
  .settings-organisation-selector strong,
  .settings-organisation-selector small {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .settings-organisation-selector strong {
    font-size: 13px;
    font-weight: 500;
    line-height: 16.9px;
  }
  .settings-organisation-selector small {
    color: var(--text-secondary, #506360);
    font-size: 11px;
    line-height: 15.4px;
  }
  .settings-organisation-selector > svg {
    width: 16px;
    height: 16px;
    flex: 0 0 auto;
    color: var(--interactive-default, #0f766e);
  }
  .settings-tabs {
    overflow: hidden;
  }
  .settings-stat-grid,
  .settings-role-fields,
  .settings-access-grid,
  .settings-module-access-grid {
    grid-template-columns: 1fr;
  }
  .settings-link-grid {
    grid-template-columns: 1fr;
  }
  .settings-empty {
    min-height: calc(100vh - 291px);
  }
  .settings-content > h1 {
    margin-top: 16px;
    font-size: 28px;
    line-height: 35px;
    letter-spacing: -0.42px;
  }
  .settings-section-heading h2 {
    font-size: 24px;
    line-height: 31.2px;
    letter-spacing: -0.24px;
  }
  .settings-card h3 {
    font-size: 20px;
    line-height: 27px;
    letter-spacing: -0.2px;
  }
  .settings-photo-card {
    padding: 20px 24px;
  }
  .settings-plan h3 {
    font-size: 24px;
    line-height: 31.2px;
  }
  .settings-stat-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  html:has(.settings-page),
  body:has(.settings-page) {
    height: auto;
    min-height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
  body:has(.settings-role-form) {
    overflow-x: clip;
    overflow-y: visible;
  }
  .settings-page,
  .settings-main,
  .settings-panel,
  .plan-billing-workspace {
    height: auto;
    min-height: 0;
    overflow: visible;
  }
  .settings-page,
  .settings-main {
    min-height: 100dvh;
  }
  .settings-content {
    min-height: calc(100dvh - 64px);
    overflow: visible;
    padding: 20px 16px calc(96px + env(safe-area-inset-bottom));
  }
  .settings-content > h1 {
    margin: 16px 0 0;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.36px;
  }
  .settings-responsive-context {
    min-height: 61px;
  }
  .settings-product-identity {
    display: none;
  }
  .settings-organisation-selector {
    width: 100%;
  }
  .settings-tabs {
    display: flex;
    width: calc(100% + 16px);
    height: 37px;
    gap: 0;
    margin: 16px -16px 20px 0;
    overflow-x: auto;
    overflow-y: hidden;
    border-bottom: 0;
    padding: 0;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }
  .settings-tabs::-webkit-scrollbar {
    display: none;
  }
  .settings-tabs button {
    width: auto;
    min-width: max-content;
    height: 37px;
    flex: 0 0 auto;
    overflow: visible;
    padding: 10px 16px;
    text-overflow: clip;
  }
  .settings-tabs button.active::after {
    bottom: 0;
  }
  .settings-tabs.mobile-billing-first button:nth-child(1) {
    order: 4;
  }
  .settings-tabs.mobile-billing-first button:nth-child(2) {
    order: 5;
  }
  .settings-tabs.mobile-billing-first button:nth-child(3) {
    order: 6;
  }
  .settings-tabs.mobile-billing-first button:nth-child(4) {
    order: 1;
  }
  .settings-tabs.mobile-billing-first button:nth-child(5) {
    order: 2;
  }
  .settings-tabs.mobile-billing-first button:nth-child(6) {
    order: 3;
  }
  .settings-section-heading {
    margin: 0 0 16px;
  }
  .settings-section-heading h2 {
    font-size: 20px;
    line-height: 26px;
    letter-spacing: -0.2px;
  }
  .settings-section-heading p {
    margin-top: 4px;
    font-size: 13px;
    line-height: 20.2px;
    letter-spacing: 0;
  }
  .settings-password-flow {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .settings-password-flow .settings-section-heading {
    margin-bottom: 0;
  }
  .settings-password-card {
    gap: 16px;
    padding: 16px;
  }
  .settings-password-card h3 {
    font-size: 18px;
    line-height: 24.3px;
    letter-spacing: -0.18px;
  }
  .settings-password-security-copy {
    max-width: 310px;
  }
  .settings-card {
    padding: 16px;
    margin-bottom: 14px;
  }
  .settings-card h3 {
    font-size: 18px;
    line-height: 24.3px;
    letter-spacing: -0.18px;
  }
  .settings-detail-grid,
  .settings-stat-grid,
  .settings-stat-grid.two {
    grid-template-columns: 1fr;
  }
  .settings-team-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .settings-detail-grid .wide {
    grid-column: auto;
  }
  .settings-business-card .settings-detail-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .settings-business-card {
    padding: 16px;
  }
  .settings-business-logo {
    min-height: 147px;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--border-subtle, #dce3e2);
  }
  .settings-business-logo-copy > span {
    margin-bottom: 0;
    font-size: 13px;
    font-weight: 500;
    line-height: 16.9px;
    letter-spacing: 0.065px;
  }
  .settings-business-logo-copy > p {
    margin-top: 8px;
    font-size: 13px;
    line-height: 18.2px;
    letter-spacing: 0.065px;
  }
  .settings-business-logo-controls {
    margin-top: 8px;
  }
  .settings-business-logo-recommendation {
    max-width: 326px;
  }
  .settings-business-card .settings-detail-grid.bordered {
    margin-top: 16px;
    padding-top: 0;
    border-top: 0;
  }
  .settings-business-card .settings-subheading {
    margin: 16px 0 12px !important;
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: -0.08px;
  }
  .settings-business-card .settings-detail-grid .wide,
  .settings-business-card .settings-detail-grid.bordered > div:last-child {
    grid-column: 1 / -1;
  }
  .settings-photo-row,
  .settings-team-links,
  .settings-heading-action {
    align-items: flex-start;
    flex-direction: column;
  }
  .settings-photo-row {
    align-items: center;
    gap: 16px;
    margin-top: 16px;
    text-align: center;
  }
  .settings-photo-row > div {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .settings-photo-row p {
    width: 100%;
    max-width: 324px;
    margin: 0 0 8px;
    font-size: 13px;
    line-height: 20.2px;
    letter-spacing: 0;
    text-align: center;
  }
  .settings-photo-card {
    min-height: 244px;
    padding: 16px;
  }
  .settings-photo-card h3 {
    font-size: 18px;
    line-height: 24.3px;
    letter-spacing: -0.18px;
  }
  .settings-photo-card .settings-button {
    min-width: 118px;
    min-height: 40px;
    padding: 0 13px;
    font-size: 13px;
    line-height: normal;
    letter-spacing: 0;
  }
  .settings-button {
    width: auto;
    height: 40px;
    min-height: 40px;
    gap: 6px;
    padding: 0 12px;
    font-size: 13px;
    line-height: normal;
    letter-spacing: 0;
  }
  .settings-card-actions {
    display: flex;
  }
  .settings-heading-action .settings-button {
    width: auto;
  }
  .settings-team-table-card th,
  .settings-team-table-card td {
    min-width: 0;
  }
  .settings-team-table-scroll {
    overflow: visible;
  }
  .settings-team-table-card {
    border: 0;
    background: transparent;
  }
  .settings-team-table-card > header {
    height: 31px;
    padding: 0;
    border: 0;
    background: transparent;
  }
  .settings-team-table-card > header h3 {
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: -0.08px;
  }
  .settings-team-table-card > header span {
    font-size: 13px;
    line-height: 20.2px;
  }
  .settings-team-table-card table,
  .settings-team-table-card tbody {
    display: block;
    width: 100%;
  }
  .settings-team-table-card thead {
    display: none;
  }
  .settings-team-table-card tbody {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
  }
  .settings-team-table-card tbody tr {
    display: grid;
    width: 100%;
    min-height: 98px;
    grid-template-columns: minmax(0, 1fr) auto 40px;
    grid-template-rows: 22px 19px 20px;
    gap: 2px 8px;
    align-content: center;
    padding: 12px 16px;
    border: 1px solid var(--border-default, #cdd6d4);
    border-radius: 10px;
    background: var(--surface-primary, #fff);
  }
  .settings-team-table-card tbody tr:nth-child(even) {
    background: var(--surface-primary, #fff);
  }
  .settings-team-table-card td {
    display: block;
    width: auto;
    height: auto;
    min-height: 0;
    padding: 0;
    border: 0;
    overflow: hidden;
    font-size: 12px;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .settings-team-table-card td[data-label="Name"] {
    grid-area: 1 / 1;
    color: var(--text-primary, #142624);
    font-size: 15px;
    font-weight: 500;
    line-height: 22px;
  }
  .settings-member-name i {
    display: none;
  }
  .settings-team-table-card td[data-label="Role"] {
    grid-area: 2 / 1;
    color: var(--interactive-default, #0f766e);
    font-size: 11px;
    font-weight: 500;
    line-height: 19px;
    text-transform: uppercase;
  }
  .settings-team-table-card td[data-label="Email"] {
    grid-area: 3 / 1;
    color: var(--text-secondary, #506360);
    font-size: 12px;
    line-height: 20px;
  }
  .settings-team-table-card td[data-label="Status"] {
    grid-area: 1 / 2;
    overflow: visible;
  }
  .settings-team-table-card td[data-label="Actions"] {
    grid-area: 1 / 3;
    overflow: visible;
  }
  .settings-team-table-card + .settings-team-table-card tbody tr {
    min-height: 78px;
    grid-template-rows: 22px 20px;
  }
  .settings-team-table-card + .settings-team-table-card td[data-label="Email"] {
    grid-area: 1 / 1;
    color: var(--text-primary, #142624);
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
  }
  .settings-team-table-card + .settings-team-table-card td[data-label="Role"] {
    grid-area: 2 / 1;
  }
  .settings-action-cell {
    width: 40px;
    text-align: center !important;
  }
  .settings-action-cell > button {
    width: 40px;
    height: 40px;
    margin: -9px 0 0;
    border-radius: 10px;
  }
  .settings-empty {
    min-height: 420px;
  }
  .settings-detail-grid {
    gap: 12px;
  }
  .settings-detail-grid > div {
    min-height: 62px;
  }
  .settings-detail-grid > div > span {
    min-height: 16px;
    margin-bottom: 6px;
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 13px;
    font-weight: var(--font-weight-medium, 500);
    line-height: 16px;
    letter-spacing: 0;
  }
  .settings-detail-grid strong {
    display: flex;
    height: 40px;
    min-height: 40px;
    align-items: center;
    padding: 0 12px;
    border-radius: 10px;
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-weight: var(--font-weight-regular, 400);
  }
  .settings-card:not(.settings-business-card) .settings-detail-grid strong {
    font-size: 14px;
    line-height: normal;
    letter-spacing: 0;
  }
  .settings-business-card .settings-detail-grid {
    gap: 16px 12px;
  }
  .settings-business-card .settings-detail-grid > div {
    min-height: 63px;
  }
  .settings-business-card .settings-detail-grid > div > span {
    min-height: 17px;
    line-height: 16.9px;
    letter-spacing: 0.065px;
  }
  .settings-business-card .settings-detail-grid strong {
    font-size: 13px;
    line-height: 20.2px;
    letter-spacing: 0;
  }
  .settings-business-card .settings-abn-field > span {
    min-height: 19px;
    font-size: 14px;
    line-height: 18.2px;
  }
  .settings-role-row {
    position: relative;
    display: block;
    padding-right: 72px;
  }
  .settings-role-row b {
    position: absolute;
    top: 0;
    right: 0;
  }
  .settings-security-card {
    align-items: flex-end;
    flex-direction: column;
    gap: 12px;
  }
  .settings-security-card > div {
    width: 100%;
  }
}

.settings-reminder-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}
.settings-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
}
.settings-switch input {
  position: absolute;
  opacity: 0;
}
.settings-switch span {
  width: 40px;
  height: 24px;
  padding: 3px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 999px;
  background: var(--surface-primary, #fff);
}
.settings-switch span::after {
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--text-disabled, #8a9896);
  transition: transform 160ms ease;
}
.settings-switch input:checked + span {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
}
.settings-switch input:checked + span::after {
  transform: translateX(16px);
  background: var(--surface-primary, #fff);
}
.reminder-list {
  max-width: 1120px;
  padding: 0 24px;
}
.reminder-row {
  display: grid;
  grid-template-columns: 40px 1fr 40px 40px;
  gap: 12px;
  align-items: center;
  min-height: 84px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.reminder-row:last-child {
  border-bottom: 0;
}
.reminder-row > i {
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  border-radius: 50%;
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}
.reminder-row > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.reminder-row strong {
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
}
.reminder-row span {
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 20.2px;
}
.reminder-row button {
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  cursor: pointer;
}
.settings-sheet-scrim {
  position: fixed;
  z-index: 1700;
  inset: 0;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  background: var(--overlay-default, rgba(15, 29, 27, 0.48));
}
.settings-sheet {
  width: min(520px, 100%);
  overflow-y: auto;
  padding: 24px;
  background: var(--surface-primary, #fff);
}
.settings-sheet-handle {
  display: none;
}
.settings-sheet header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  padding-bottom: 16px;
}
.settings-sheet h3 {
  margin: 0;
  font-size: 18px;
  line-height: 24.3px;
}
.settings-sheet header p {
  margin: 4px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 21.7px;
}
.settings-sheet header button {
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  color: var(--interactive-default, #0f766e);
  cursor: pointer;
}
.reminder-preview-summary {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 16px;
  padding: 16px;
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f7);
}
.reminder-preview-summary > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.reminder-preview-summary span,
.reminder-preview > p {
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 20.2px;
}
.reminder-preview-meta {
  display: grid;
  grid-template-columns: 44px 1fr;
  gap: 14px 12px;
  margin-top: 16px;
  padding: 16px 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  font-size: 13px;
}
.reminder-preview-meta span {
  color: var(--text-secondary, #506360);
  font-weight: 500;
}
.reminder-preview-meta b {
  font-weight: 400;
}
.reminder-preview article,
.reminder-email-preview article {
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  padding: 16px;
  font-size: 13px;
  line-height: 20.2px;
}
.reminder-preview article h4 {
  margin: 0 0 16px;
  font-size: 16px;
}
.reminder-preview article aside,
.reminder-edit-card aside {
  border-radius: 10px;
  padding: 12px 16px;
  background: var(--info-soft, #eef5ff);
  color: var(--info-text, #165dce);
}
.settings-inline-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 20px;
  border: 0;
  background: transparent;
  color: var(--interactive-default, #0f766e);
  font: 500 13px/17px var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.reminder-edit-card {
  display: flex;
  max-width: 720px;
  flex-direction: column;
  gap: 10px;
}
.reminder-edit-card > label,
.payment-edit-card label {
  font-size: 13px;
  font-weight: 500;
}
.reminder-edit-card > input,
.reminder-edit-card textarea,
.reminder-timing input,
.reminder-timing select,
.reminder-toolbar select,
.payment-edit-card input {
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 13px/20px var(--font-family-primary, "Lexend", sans-serif);
}
.reminder-edit-card > input,
.reminder-timing input,
.reminder-timing select,
.payment-edit-card input {
  height: 40px;
  padding: 0 10px;
}
.reminder-timing {
  display: grid;
  grid-template-columns: 80px 100px 1fr;
  align-items: center;
  gap: 8px;
}
.reminder-toolbar {
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 40px;
  padding: 4px 8px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
}
.reminder-toolbar select {
  height: 30px;
}
.reminder-edit-card textarea {
  min-height: 160px;
  resize: vertical;
  padding: 10px;
}
.reminder-edit-card footer,
.payment-edit-card footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.reminder-email-preview {
  max-width: 720px;
  color: var(--text-secondary, #506360);
  font-size: 11px;
}
.reminder-email-preview article {
  margin-top: 12px;
  color: var(--text-primary, #142624);
  background: var(--surface-primary, #fff);
}
.payment-details-card,
.payment-edit-card {
  max-width: 1120px;
}
.payment-success {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  border-radius: 14px;
  padding: 16px;
  background: var(--success-soft, #eaf8ef);
  color: var(--success-text, #167044);
}
.payment-success p {
  margin: 4px 0 0;
  color: inherit;
}
.payment-values {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  padding: 16px;
}
.payment-values span {
  color: var(--text-secondary, #506360);
  font-size: 13px;
}
.payment-values strong {
  margin-bottom: 4px;
  font-size: 14px;
}
.payment-edit-card {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.payment-edit-card label {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.payment-edit-card label b {
  color: var(--danger-text, #a3301f);
}
.payment-required-label {
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
}
.payment-edit-card label small {
  min-height: 16px;
  color: var(--text-secondary, #506360);
  font-size: 11px;
  font-weight: 400;
  line-height: 15.4px;
}
.payment-edit-card label.error input {
  border-color: var(--danger-default, #c23a2b);
}
.payment-edit-card label.error small,
.payment-form-error {
  color: var(--danger-text, #a3301f);
}
.payment-form-error {
  margin: 0;
  font-size: 12px;
}
.payment-edit-card > div {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 640px) {
  .settings-reminder-heading {
    gap: 12px;
  }
  .settings-reminder-heading > div {
    min-width: 0;
  }
  .settings-reminder-heading .settings-switch {
    flex: 0 0 auto;
    margin-top: 2px;
  }
  .reminder-list {
    padding: 10px 16px;
  }
  .reminder-row {
    grid-template-columns: 40px 1fr 32px 32px;
    gap: 8px;
    min-height: 90px;
  }
  .reminder-row button {
    width: 32px;
    height: 32px;
  }
  .settings-sheet-scrim {
    align-items: flex-end;
    justify-content: stretch;
  }
  .settings-sheet {
    width: 100%;
    max-height: calc(100dvh - 16px);
    overscroll-behavior: contain;
    border-radius: 20px 20px 0 0;
    padding: 8px 16px calc(16px + env(safe-area-inset-bottom));
  }
  .settings-sheet-handle {
    display: block;
    width: 40px;
    height: 4px;
    margin: 0 auto 14px;
    border-radius: 999px;
    background: var(--border-default, #cdd6d4);
  }
  .settings-sheet header {
    margin-inline: -16px;
    padding: 0 16px 16px;
  }
  .settings-sheet header p {
    font-size: 13px;
    line-height: 20.2px;
  }
  .reminder-preview article {
    padding: 16px;
  }
  .reminder-edit-card {
    padding: 12px;
  }
  .reminder-timing {
    grid-template-columns: 76px 76px 1fr;
  }
  .reminder-edit-card footer {
    justify-content: flex-end;
  }
  .payment-edit-card > div {
    grid-template-columns: 1fr;
  }
  .settings-payment-heading {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px 12px;
  }
  .settings-payment-heading > div {
    display: contents;
  }
  .settings-payment-heading h2 {
    grid-area: 1 / 1;
    align-self: center;
  }
  .settings-payment-heading p {
    grid-area: 2 / 1 / 3 / -1;
  }
  .settings-payment-heading > .settings-button {
    grid-area: 1 / 2;
    height: 36px;
    min-height: 36px;
    align-self: center;
    gap: 6px;
    padding: 0 12px;
    font-size: 13px;
  }
  .payment-details-card {
    min-height: 399px;
    padding: 16px;
  }
  .payment-success {
    min-height: 89px;
    margin-bottom: 20px;
    padding: 16px;
  }
  .payment-values {
    min-height: 208px;
    padding: 16px;
  }
  .payment-details-card > p {
    margin: 20px 0 0;
    font-size: 11px;
    line-height: 15.4px;
  }
  .payment-empty-card {
    min-height: 326px;
    padding: 48px 32px;
  }
  .settings-payment-edit-heading {
    margin-bottom: 16px;
  }
  .payment-edit-card {
    gap: 12px;
    margin-bottom: 0;
    padding: 16px;
  }
  .payment-edit-card input {
    border-radius: 10px;
  }
  .payment-edit-card footer {
    gap: 12px;
    margin-top: 12px;
  }
  .payment-edit-card footer .settings-button {
    height: 40px;
    min-height: 40px;
  }
  .settings-heading-action {
    align-items: flex-start;
  }
  .settings-heading-action > .settings-button {
    align-self: flex-end;
  }
  .settings-team-workspace > .settings-heading-action {
    gap: 12px;
  }
  .settings-team-workspace > .settings-heading-action > .settings-button {
    width: 100%;
    min-height: 40px;
    align-self: stretch;
  }
  .settings-team-workspace > .settings-team-tabs {
    width: 100%;
    margin: 16px 0 20px;
  }
  .settings-team-workspace > .settings-team-tabs button {
    min-height: 41px;
    padding-inline: 16px;
  }
  .settings-team-stats {
    gap: 8px;
    margin-bottom: 20px;
  }
  .settings-team-stats section {
    min-height: 103px;
    padding: 16px 20px;
  }
  .settings-team-stats span {
    font-size: 13px;
    line-height: 20.2px;
  }
  .settings-team-stats strong {
    margin: 3px 0 1px;
    font-size: 20px;
    line-height: 26px;
  }
  .settings-team-stats small {
    font-size: 11px;
    line-height: 15.4px;
  }
}

/* Plan & billing — Figma section 1926:167062 */
.plan-billing-workspace {
  width: 100%;
}
.plan-billing-workspace button,
.plan-billing-workspace input,
.plan-billing-workspace select {
  font-family: inherit;
}
.plan-billing-heading {
  position: relative;
}
.plan-billing-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 12px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--text-link, var(--interactive-default));
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.plan-billing-back svg {
  width: 16px;
  height: 16px;
}
.plan-billing-button {
  display: inline-flex;
  height: 44px;
  min-height: 44px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  border: 1px solid transparent;
  border-radius: 10px;
  font-size: 14px;
  font-weight: var(--font-weight-medium, 500);
  line-height: normal;
  letter-spacing: 0;
  white-space: nowrap;
  cursor: pointer;
}
.plan-billing-button.primary {
  color: var(--on-interactive-primary, #fff);
  background: var(--interactive-default, #0f766e);
}
.plan-billing-button.secondary {
  color: var(--text-primary);
  border-color: var(--border-default);
  background: var(--surface-primary);
}
.plan-billing-button.primary:hover:not(:disabled) {
  border-color: var(--interactive-hover, var(--interactive-default));
  background: var(--interactive-hover, var(--interactive-default));
}
.plan-billing-button.secondary:hover:not(:disabled) {
  border-color: var(--border-strong, var(--border-default));
  background: var(--surface-secondary);
}
.plan-billing-button:disabled {
  color: var(--text-disabled, #8a9896);
  border-color: var(--border-subtle);
  background: var(--surface-secondary);
  cursor: not-allowed;
}
.plan-current-card,
.plan-usage-grid > section,
.plan-navigation-grid > section,
.plan-summary-grid > section,
.billing-status-grid > section,
.billing-contact-card,
.billing-payment-card,
.add-card-panel,
.payment-saved-panel,
.available-plan-grid > section {
  border: 1px solid var(--border-default);
  border-radius: 14px;
  background: var(--surface-primary);
}
.plan-current-card {
  display: flex;
  min-height: 180px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 16px;
  padding: 20px 28px;
}
.plan-current-card > div {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 8px;
}
.plan-current-card small,
.billing-status-grid small,
.available-plan-grid small {
  color: var(--interactive-default);
  font-size: 11px;
  line-height: 14.3px;
  font-weight: 600;
  letter-spacing: 0.88px;
}
.plan-current-card h3 {
  margin: 0;
  font-size: 28px;
  line-height: 36.4px;
  font-weight: 600;
  letter-spacing: -0.28px;
}
.plan-current-card strong {
  font: 400 16px/25.6px var(--font-family-mono, monospace);
}
.plan-current-card span,
.plan-current-card p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 21.7px;
}
.plan-current-card p {
  color: var(--text-primary);
  font-size: 16px;
  line-height: 25.6px;
}
.plan-usage-grid,
.plan-navigation-grid,
.plan-summary-grid,
.billing-status-grid,
.available-plan-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}
.plan-usage-grid > section {
  display: flex;
  min-height: 184px;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
}
.plan-usage-grid svg {
  width: 20px;
  height: 20px;
  color: var(--interactive-default);
}
.plan-usage-grid span {
  font-size: 14px;
  line-height: 18.2px;
  font-weight: 500;
}
.plan-usage-grid strong {
  font-size: 28px;
  line-height: 36.4px;
  font-weight: 600;
  letter-spacing: -0.28px;
}
.plan-usage-grid p {
  flex: 1 1;
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 21.7px;
}
.plan-usage-grid button,
.plan-navigation-grid button,
.available-plan-heading button {
  width: -moz-fit-content;
  width: fit-content;
  padding: 0;
  border: 0;
  background: none;
  color: var(--text-link, var(--interactive-default));
  font-size: 13px;
  line-height: 18px;
  font-weight: 500;
  cursor: pointer;
}
.plan-navigation-grid > section {
  display: flex;
  min-height: 160px;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
}
.plan-navigation-grid h3,
.available-plan-heading h3 {
  margin: 0;
  font-size: 18px;
  line-height: 25.2px;
  font-weight: 500;
  letter-spacing: -0.09px;
}
.plan-navigation-grid p {
  flex: 1 1;
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 21.7px;
}
.plan-navigation-grid button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.plan-summary-grid {
  grid-template-columns: 1fr 1fr 0.7fr;
}
.plan-summary-grid > section {
  display: flex;
  min-height: 112px;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
}
.plan-summary-grid span {
  color: var(--text-secondary);
  font-size: 13px;
}
.plan-summary-grid strong {
  font-size: 20px;
  font-weight: 500;
}
.plan-summary-grid small {
  color: var(--text-secondary);
  font-size: 12px;
}
.plan-history-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0 16px;
}
.plan-history-toolbar > div {
  display: flex;
  gap: 10px;
}
.plan-history-toolbar select {
  min-width: 120px;
  height: 44px;
  padding: 0 30px 0 12px;
  border: 1px solid var(--border-default);
  border-radius: 10px;
  color: var(--text-primary);
  background: var(--surface-primary);
}
.plan-history-table-wrap {
  overflow: hidden;
  border: 1px solid var(--border-default);
  border-radius: 14px;
  background: var(--surface-primary);
}
.plan-history-table {
  width: 100%;
  border-collapse: collapse;
}
.plan-history-table th,
.plan-history-table td {
  height: 52px;
  padding: 0 16px;
  border-bottom: 1px solid var(--border-subtle);
  text-align: left;
  font-size: 13px;
  font-weight: 400;
}
.plan-history-table th {
  height: 44px;
  color: var(--text-secondary);
  background: var(--surface-secondary);
  font-weight: 500;
}
.plan-history-table td:first-child {
  color: var(--text-link);
  font-family: var(--font-family-mono, monospace);
}
.plan-history-table td > span {
  padding: 5px 8px;
  border-radius: 999px;
  color: var(--success-text);
  background: var(--success-soft);
  font-size: 11px;
}
.plan-history-table td button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--text-link);
  text-decoration: underline;
  cursor: pointer;
}
.plan-history-table-wrap > footer {
  display: flex;
  min-height: 52px;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  color: var(--text-secondary);
  font-size: 12px;
}
.plan-history-table-wrap footer div {
  display: flex;
  gap: 8px;
}
.plan-history-table-wrap footer button {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 1px solid var(--border-subtle);
  border-radius: 8px;
  color: var(--text-secondary);
  background: transparent;
}
.credit-management-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}
.credit-management-summary > section,
.credit-topup-card,
.credit-usage-card {
  border: 1px solid var(--border-default);
  border-radius: 14px;
  background: var(--surface-primary);
}
.credit-management-summary > section {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 5px 12px;
  padding: 18px 20px;
}
.credit-management-summary svg {
  grid-row: 1 / span 3;
  width: 22px;
  height: 22px;
  color: var(--interactive-default);
}
.credit-management-summary span,
.credit-management-summary small {
  color: var(--text-secondary);
  font-size: 13px;
}
.credit-management-summary strong {
  font-size: 22px;
  line-height: 29px;
  font-weight: 600;
}
.credit-management-summary .app-skeleton {
  max-width: 100%;
}
.credit-topup-card {
  margin-bottom: 16px;
  padding: 20px;
}
.credit-topup-card h3,
.credit-usage-card h3 {
  margin: 0 0 5px;
  font-size: 18px;
  line-height: 25px;
  font-weight: 500;
}
.credit-topup-card p,
.credit-usage-card p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 20px;
}
.credit-topup-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 18px;
}
.credit-topup-fields label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
}
.credit-topup-fields label b {
  color: var(--danger-text);
}
.credit-topup-fields input,
.credit-usage-search {
  height: 42px;
  box-sizing: border-box;
  border: 1px solid var(--border-default);
  border-radius: 10px;
  color: var(--text-primary);
  background: var(--surface-primary);
}
.credit-topup-fields input {
  height: 32px;
  padding: 0 10px;
  outline: 0;
  font: 400 13px / normal var(--font-family-primary, "Lexend", sans-serif);
}
.credit-topup-fields input:focus {
  border: 2px solid var(--interactive-default);
  padding: 0 9px;
  box-shadow: 0 0 0 3px rgba(15, 186, 196, 0.22);
}
.credit-topup-fields label.has-error input {
  border-color: var(--danger-default, #c23a2b);
  box-shadow: none;
}
.credit-topup-fields input[readonly] {
  border-color: var(--border-subtle);
  color: var(--text-disabled, #8a9896);
  background: var(--surface-secondary);
  opacity: 0.75;
}
.credit-topup-fields small {
  min-height: 14px;
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 400;
  line-height: normal;
}
.credit-topup-fields label.has-error small {
  color: var(--danger-default, #c23a2b);
}
.credit-topup-card footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 18px;
}
.plan-billing-button.primary.credit-topup-submit[aria-busy="true"] {
  border-color: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
  background: var(--interactive-default, #0f766e);
  opacity: 1;
  cursor: wait;
}
.credit-topup-submit {
  width: 120px;
  min-width: 120px;
  height: 40px;
  min-height: 40px;
  gap: 8px;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
}
.credit-topup-submit .credit-topup-spinner {
  color: currentColor;
}
.credit-payment-link {
  border: 0;
  background: transparent;
  color: var(--text-link);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.credit-topup-card .credit-management-message {
  margin-top: 12px;
  color: var(--text-primary);
}
.credit-usage-card {
  overflow: hidden;
}
.credit-usage-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 20px;
}
.credit-usage-search {
  display: flex;
  width: min(100%, 320px);
  align-items: center;
  gap: 8px;
  padding: 0 6px 0 12px;
}
.credit-usage-search > svg {
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  color: var(--text-secondary);
}
.credit-usage-search:hover {
  border-color: var(--border-strong, #aebab8);
}
.credit-usage-search:focus-within {
  border-color: var(--interactive-default, #0f766e);
}
.credit-usage-search input {
  min-width: 0;
  flex: 1 1;
  border: 0;
  outline: 0;
  padding: 0;
  color: var(--text-primary);
  background: transparent;
  font: 400 14px / normal var(--font-family-primary, "Lexend", sans-serif);
}
.credit-usage-search input::placeholder {
  color: var(--text-secondary);
}
.credit-usage-table-wrap {
  overflow-x: auto;
}
.credit-usage-table {
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
}
.credit-usage-table th,
.credit-usage-table td {
  height: 52px;
  padding: 0 16px;
  border-top: 1px solid var(--border-subtle);
  text-align: left;
  font-size: 13px;
  font-weight: 400;
}
.credit-usage-table th {
  height: 44px;
  color: var(--text-secondary);
  background: var(--surface-secondary);
  font-weight: 500;
}
.credit-usage-table th:nth-child(n + 3),
.credit-usage-table td:nth-child(n + 3) {
  text-align: right;
  font-family: var(--font-family-mono, monospace);
}
.credit-usage-table td[colspan] {
  color: var(--text-secondary);
  text-align: center;
  font-family: inherit;
}
.credit-usage-skeleton-row .app-skeleton {
  max-width: 100%;
}
.credit-usage-skeleton-row td:nth-child(n + 3) .app-skeleton {
  margin-left: auto;
}
.credit-usage-filler-row td {
  color: transparent;
  -webkit-user-select: none;
          user-select: none;
}
.credit-usage-empty-row {
  height: 520px;
}
.credit-usage-table .credit-positive {
  color: var(--success-text);
}
.credit-usage-card > footer {
  display: flex;
  min-height: 54px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-top: 1px solid var(--border-subtle);
  padding: 0 16px;
  color: var(--text-secondary);
  font-size: 12px;
}
.credit-usage-card > footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}
.credit-usage-card > footer button {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 1px solid var(--border-subtle);
  border-radius: 8px;
  color: var(--text-secondary);
  background: transparent;
  cursor: pointer;
}
.credit-usage-card > footer button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.billing-status-grid {
  grid-template-columns: 1fr 1fr;
}
.billing-status-grid > section {
  display: flex;
  min-height: 118px;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
}
.billing-status-grid strong {
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
}
.billing-status-grid span {
  font-size: 14px;
}
.billing-contact-card,
.billing-payment-card,
.add-card-panel {
  position: relative;
  margin-bottom: 16px;
  padding: 24px;
}
.billing-contact-card h3,
.billing-payment-card h3,
.add-card-panel h3,
.payment-saved-panel h3 {
  margin: 0 0 8px;
  font-size: 22px;
  line-height: 29.7px;
  font-weight: 500;
  letter-spacing: -0.22px;
}
.billing-contact-card > p,
.billing-payment-card p {
  margin: 0 0 16px;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 21.7px;
}
.billing-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
}
.billing-form-grid label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
}
.billing-form-grid label b {
  color: var(--danger-text);
}
.billing-required-label {
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
}
.billing-form-grid input {
  width: 100%;
  height: 42px;
  padding: 0 12px;
  border: 1px solid var(--border-default);
  border-radius: 8px;
  outline: none;
  color: var(--text-primary);
  background: var(--surface-primary);
  font-size: 14px;
}
.billing-form-grid input:focus {
  border-color: var(--interactive-default);
  box-shadow: none;
}
.billing-form-grid input.error {
  border-color: var(--danger-default);
}
.billing-form-grid small {
  min-height: 17px;
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 400;
}
.billing-form-grid input.error + small {
  color: var(--danger-text);
}
.billing-payment-card {
  min-height: 140px;
}
.billing-payment-card > .plan-billing-button {
  position: absolute;
  top: 20px;
  right: 20px;
}
.billing-saved-card {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 18px;
}
.billing-saved-card > div:last-child p {
  margin: 5px 0;
}
.billing-saved-card em,
.payment-saved-panel em {
  margin-left: 6px;
  padding: 4px 8px;
  border-radius: 999px;
  color: var(--interactive-default);
  background: var(--interactive-soft);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
}
.plan-card-visual {
  position: relative;
  display: grid;
  width: 300px;
  height: 160px;
  flex: 0 0 auto;
  grid-template-columns: 1fr 1fr;
  align-content: space-between;
  padding: 20px;
  border-radius: 14px;
  color: #fff;
  background: linear-gradient(120deg, #0d8ea0, #06343b);
  box-shadow: inset 0 0 38px rgba(0, 0, 0, 0.16);
}
.plan-card-visual > b {
  grid-column: 1 / -1;
  font-size: 12px;
}
.plan-card-visual > i {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 34px;
  height: 25px;
  border-radius: 5px;
  background: #e9a020;
}
.plan-card-visual > strong {
  grid-column: 1 / -1;
  font: 500 14px/20px var(--font-family-mono, monospace);
}
.plan-card-visual > span {
  font-size: 9px;
  line-height: 16px;
}
.plan-card-visual > span:last-child {
  text-align: right;
}
.billing-footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}
.add-card-panel {
  padding: 24px;
}
.payment-security-copy {
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 20px;
}
.payment-saved-panel {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 24px;
}
.payment-saved-panel > div:last-child {
  flex: 1 1;
}
.payment-saved-panel p {
  max-width: 620px;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 21.7px;
}
.available-plan-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 10px 0 16px;
}
.available-plan-heading p,
.plan-comparison > p {
  margin: 4px 0 0;
  color: var(--text-secondary);
  font-size: 13px;
}
.available-plan-grid > section {
  display: flex;
  min-height: 360px;
  flex-direction: column;
  padding: 16px;
}
.available-plan-grid > section.current {
  border: 2px solid var(--interactive-default);
  padding: 15px;
}
.available-plan-grid h3 {
  margin: 0 0 8px;
  font-size: 24px;
  line-height: 31px;
  font-weight: 600;
}
.available-plan-grid p {
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 20px;
}
.available-plan-grid > section > strong {
  font: 400 14px/22px var(--font-family-mono, monospace);
}
.available-plan-grid hr {
  width: 100%;
  margin: 10px 0;
  border: 0;
  border-top: 1px solid var(--border-subtle);
}
.available-plan-grid ul {
  flex: 1 1;
  margin: 10px 0 16px;
  padding: 0;
  list-style: none;
}
.available-plan-grid li {
  display: flex;
  gap: 7px;
  margin: 9px 0;
  color: var(--text-secondary);
  font-size: 13px;
}
.available-plan-grid li svg {
  flex: 0 0 auto;
}
.plan-comparison {
  margin: 28px 16px 0;
}
.plan-comparison h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}
.plan-comparison > div {
  overflow-x: auto;
  margin-top: 12px;
  border: 1px solid var(--border-default);
  border-radius: 12px;
}
.plan-comparison table {
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
}
.plan-comparison th,
.plan-comparison td {
  height: 44px;
  padding: 0 16px;
  border-bottom: 1px solid var(--border-subtle);
  text-align: left;
  font-size: 12px;
  font-weight: 400;
}
.plan-comparison th {
  background: var(--surface-secondary);
  font-weight: 500;
}
.plan-comparison tr:nth-child(even) {
  background: var(--surface-secondary);
}
.plan-modal-backdrop {
  position: fixed;
  z-index: 1600;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 20px;
  background: var(--overlay-default, rgba(15, 29, 27, 0.48));
}
.plan-modal {
  width: min(520px, 100%);
  overflow: hidden;
  border: 1px solid var(--border-subtle);
  border-radius: 20px;
  color: var(--text-primary);
  background: var(--surface-elevated, var(--surface-primary));
  box-shadow: 0 6px 8px rgba(14, 26, 32, 0.1), 0 1px 1px rgba(14, 26, 32, 0.04);
}
.plan-modal header {
  display: flex;
  min-height: 73px;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  padding: 28px 28px 20px;
  border-bottom: 1px solid var(--border-subtle);
}
.plan-modal h3 {
  flex: 1 1;
  margin: 0;
  font-size: 16px;
  line-height: 22.4px;
  font-weight: 500;
  letter-spacing: -0.08px;
}
.plan-modal-title-icon {
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  color: var(--danger-default, #c23a2b);
  stroke-width: 1.75;
}
.plan-modal header button {
  display: grid;
  place-items: center;
  padding: 5px;
  border: 0;
  color: var(--text-secondary);
  background: none;
  cursor: pointer;
}
.plan-modal header button svg {
  width: 20px;
  height: 20px;
  stroke-width: 1.75;
}
.plan-modal > div {
  padding: 20px 28px 12px;
}
.plan-modal.subscription-modal--confirm > div {
  padding: 24px 28px 0;
}
.plan-modal p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 20.2px;
}
.plan-modal footer {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  justify-content: flex-end;
  gap: 12px;
  min-height: auto;
  padding: 28px !important;
}
.plan-modal.subscription-modal--confirm footer {
  min-height: auto;
  padding: 28px !important;
}
.plan-modal footer .plan-billing-button {
  height: 40px;
  min-height: 40px;
  padding: 0 12px;
  font-size: 13px;
  line-height: 16.9px;
  letter-spacing: 0.065px;
}
.plan-cancel-link {
  min-height: 40px;
  padding: 0 16px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--danger-default, #c23a2b) !important;
  -webkit-text-fill-color: var(--danger-default, #c23a2b);
  font: 500 13px/16.9px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0.065px;
  cursor: pointer;
}

@media (max-width: 900px) {
  .plan-usage-grid,
  .available-plan-grid {
    grid-template-columns: 1fr;
  }
  .plan-usage-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .plan-navigation-grid {
    grid-template-columns: 1fr;
  }
  .plan-summary-grid {
    grid-template-columns: repeat(3, minmax(190px, 1fr));
    overflow-x: auto;
  }
  .plan-history-table-wrap {
    overflow-x: auto;
  }
  .plan-history-table {
    min-width: 850px;
  }
  .billing-saved-card,
  .payment-saved-panel {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (max-width: 640px) {
  .plan-billing-button {
    height: 40px;
    min-height: 40px;
    gap: 6px;
    padding: 0 12px;
    font-size: 13px;
  }
  .plan-usage-grid {
    grid-template-columns: 1fr;
  }
  .plan-current-card,
  .available-plan-heading {
    flex-direction: column;
  }
  .billing-status-grid,
  .billing-form-grid,
  .credit-management-summary,
  .credit-topup-fields {
    grid-template-columns: 1fr;
  }
  .credit-usage-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .credit-usage-search {
    width: 100%;
  }
  .credit-topup-card footer {
    align-items: stretch;
    flex-direction: column-reverse;
  }
  .credit-topup-card footer .plan-billing-button {
    width: 100%;
  }
  .credit-usage-card > footer {
    align-items: flex-start;
    flex-direction: column;
    padding-block: 12px;
  }
  .plan-history-toolbar {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
  .plan-history-toolbar > div {
    width: 100%;
  }
  .plan-history-toolbar select,
  .plan-history-toolbar .plan-billing-button {
    flex: 1 1;
  }
  .billing-payment-card {
    padding-top: 78px;
  }
  .billing-payment-card > .plan-billing-button {
    right: 16px;
    left: 16px;
  }
  .plan-card-visual {
    width: 100%;
    max-width: 300px;
  }
  .billing-footer-actions,
  .plan-modal footer {
    flex-wrap: wrap;
  }
  .plan-modal-backdrop {
    align-items: end;
    padding: 0;
  }
  .plan-modal.subscription-modal {
    width: 100%;
    max-height: calc(100dvh - 16px);
    overflow-y: auto;
    overscroll-behavior: contain;
    border-radius: 20px 20px 0 0;
    padding-bottom: env(safe-area-inset-bottom);
  }
  .plan-modal.subscription-modal footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
  .plan-modal.subscription-modal footer .plan-billing-button {
    width: auto;
  }
}

@media (max-width: 640px) {
  .settings-profile-fields {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .settings-profile-fields .wide {
    grid-column: auto;
  }
  .settings-photo-actions {
    justify-content: center;
  }
  .settings-photo-actions .settings-button {
    min-width: 118px;
  }
  .settings-role-row {
    align-items: flex-start;
  }
  .settings-role-row p {
    font-size: 13px;
    line-height: 20.2px;
  }
  .settings-personal-card .settings-card-actions .settings-button,
  .settings-security-card > .settings-button,
  .settings-password-actions .settings-button {
    height: 40px;
    min-height: 40px;
  }
  .settings-personal-card .settings-card-actions .settings-button {
    width: auto;
    height: 40px;
    min-height: 40px;
    flex: 0 0 auto;
    gap: 6px;
    border-radius: var(--radius-md, 10px);
    padding: 0 12px;
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 13px;
    font-weight: var(--font-weight-medium, 500);
    line-height: normal;
    letter-spacing: 0;
    cursor: pointer;
  }
  .settings-personal-card .settings-card-actions .settings-button:disabled {
    cursor: default;
    opacity: 0.65;
  }
  .settings-photo-dialog-scrim {
    align-items: end;
    padding: 0;
  }
  .settings-photo-dialog {
    width: 100%;
    height: 427px;
    max-height: calc(100vh - 16px);
    max-height: calc(100dvh - 16px);
    min-height: 0;
    overflow: hidden;
    overscroll-behavior: contain;
    gap: 16px;
    border-radius: 20px 20px 0 0;
    padding: 16px;
    box-shadow: 0 1px 2px rgba(14, 26, 32, 0.04),
      0 6px 16px -4px rgba(14, 26, 32, 0.1);
  }
  .settings-photo-dialog-body {
    scrollbar-width: none;
    touch-action: pan-y;
  }
  .settings-photo-dialog-body::-webkit-scrollbar {
    display: none;
  }
  .settings-photo-dialog h2 {
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
    letter-spacing: -0.08px;
  }
  .settings-photo-dialog header button {
    width: auto;
    height: 30px;
    padding: 0;
    color: var(--interactive-default, #0f766e);
    font: 500 13px / 16.9px var(--font-family-primary, "Lexend", sans-serif);
  }
  .settings-photo-dialog header button svg {
    display: none;
  }
  .settings-photo-dialog header button span {
    display: inline;
  }
  .settings-photo-dialog-body > p {
    font-size: 13px;
    line-height: 20.2px;
  }
  .settings-photo-dialog-preview {
    width: 100%;
    height: 210px;
    min-height: 210px;
    flex: 0 0 210px;
    padding: 20px 16px;
  }
  .settings-photo-dialog-preview .settings-avatar {
    width: 88px;
    height: 88px;
    border-width: 2px;
    font-size: 24px;
    font-weight: 500;
    line-height: normal;
  }
  .settings-photo-dialog-preview strong {
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
  }
  .settings-photo-dialog-preview small,
  .settings-photo-dialog-note {
    font-size: 11px;
    line-height: 15.4px;
    letter-spacing: 0.11px;
  }
  .settings-photo-dialog .settings-photo-choose {
    width: 100%;
    height: 44px;
    min-height: 44px;
    flex: 0 0 44px;
    padding: 0 16px;
    font-size: 14px;
    line-height: normal;
  }
  .settings-photo-dialog-actions .settings-button {
    width: auto;
    height: 44px;
    min-height: 44px;
    flex: 1 1;
    padding: 0 16px;
    font-size: 14px;
    line-height: normal;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Settings/Settings.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,mCAAmC;EACnC,6DAA6D;AAC/D;;AAEA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,sDAAsD;EACtD,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,+CAA+C;AACjD;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,gDAAgD;EAChD,qCAAqC;EACrC,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,qCAAqC;EACrC,eAAe;EACf,6DAA6D;EAC7D,qBAAqB;EACrB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;AAC5C;AACA;EACE,gDAAgD;EAChD,mCAAmC;EACnC,wCAAwC;AAC1C;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,2EAA2E;EAC3E,yEAAyE;AAC3E;AACA;EACE,2CAA2C;EAC3C,6CAA6C;AAC/C;AACA;;;;;;;;EAQE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,6CAA6C;EAC7C,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;;;EAIE,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,qCAAqC;EACrC,UAAU;EACV,eAAe;EACf,wCAAwC;EACxC,mCAAmC;EACnC,sEAAsE;AACxE;AACA;;EAEE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,4CAA4C;EAC5C,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,mCAAmC;EACnC,wEAAwE;AAC1E;AACA;EACE,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,kCAAkC;AACpC;AACA;;EAEE,oBAAoB;EACpB,0BAA0B;EAC1B,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;;;EAGE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;;;EAIE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;EACnC,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,qCAAqC;EACrC,UAAU;EACV,eAAe;EACf,wCAAwC;EACxC,mCAAmC;EACnC,wEAAwE;AAC1E;AACA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,0DAA0D;AAC5D;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gDAAgD;EAChD,qCAAqC;EACrC,aAAa;EACb,wCAAwC;EACxC,+DAA+D;AACjE;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;AACnC;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,qCAAqC;EACrC,6CAA6C;EAC7C,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;EAC/C,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+CAA+C;EAC/C,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;EAC/C,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,0BAA0B;EAC1B,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,sDAAsD;AACxD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,4CAA4C;EAC5C,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,gDAAgD;AAClD;AACA;EACE,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,SAAO;AACT;AACA;;EAEE,0CAA0C;EAC1C,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,4DAA4D;AAC9D;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,SAAO;AACT;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,sDAAsD;EACtD,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,qCAAqC;EACrC,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,WAAW;EACX,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;;EAEE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,mDAAmD;EACnD,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,6CAA6C;EAC7C,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,4CAA4C;EAC5C,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,4CAA4C;AAC9C;AACA;;;;EAIE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gDAAgD;EAChD,mBAAmB;EACnB,wCAAwC;EACxC,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,kCAAkC;AACpC;AACA;;EAEE,qCAAqC;EACrC,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,QAAQ;EACR,mDAAmD;AACrD;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,mCAAmC;EACnC,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;;EAEE,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;AAClB;AACA;;;EAGE,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;AACA;;EAEE,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,qCAAqC;EACrC,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mDAAmD;AACrD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,qCAAqC;AACvC;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kDAAkD;EAClD,SAAS;EACT,qCAAqC;EACrC,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iDAAiD;EACjD,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;EACf,wCAAwC;EACxC;0DACwD;EACxD,kCAAkC;EAClC,gEAAgE;AAClE;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gDAAgD;AAClD;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,wDAAwD;IACxD,wBAAwB;IACxB,4BAA4B;IAC5B,eAAe;EACjB;EACA;IACE,iDAAiD;IACjD,wBAAwB;EAC1B;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,iDAAiD;AACnD;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,6CAA6C;EAC7C,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;EACjC,qBAAqB;EACrB,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,+CAA+C;IAC/C,mBAAmB;IACnB,mCAAmC;IACnC,wCAAwC;IACxC,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,+CAA+C;IAC/C,mBAAmB;IACnB,wCAAwC;EAC1C;EACA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,iDAAiD;IACjD,kBAAkB;IAClB,0CAA0C;IAC1C,4CAA4C;IAC5C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,YAAY;IACZ,SAAO;IACP,sBAAsB;IACtB,QAAQ;EACV;EACA;;IAEE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,qCAAqC;IACrC,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,0CAA0C;EAC5C;EACA;IACE,gBAAgB;EAClB;EACA;;;;IAIE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gDAAgD;EAClD;AACF;AACA;EACE;;IAEE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;;;;IAIE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,+BAA+B;IAC/B,iBAAiB;IACjB,2DAA2D;EAC7D;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,wBAAwB;IACxB,YAAY;IACZ,MAAM;IACN,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,iCAAiC;EACnC;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,aAAa;EACf;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;EACA;;;IAGE,0BAA0B;EAC5B;EACA;IACE,gDAAgD;EAClD;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gDAAgD;EAClD;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,sDAAsD;EACxD;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,aAAa;EACf;EACA;IACE,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;EACA;;IAEE,mBAAmB;EACrB;EACA;;;IAGE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;;IAEE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,UAAU;IACV,SAAS;IACT,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;;IAEE,cAAc;IACd,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;EACjB;EACA;IACE,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,+CAA+C;IAC/C,kCAAkC;IAClC,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,gDAAgD;IAChD,mBAAmB;IACnB,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;EACA;IACE,gBAAgB;IAChB,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,6DAA6D;IAC7D,eAAe;IACf,2CAA2C;IAC3C,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,6DAA6D;IAC7D,4CAA4C;EAC9C;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;EACV;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gDAAgD;EAChD,oBAAoB;EACpB,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,gCAAgC;AAClC;AACA;EACE,iDAAiD;EACjD,+CAA+C;AACjD;AACA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,sDAAsD;AACxD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,0DAA0D;AAC5D;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,sDAAsD;EACtD,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;EAEE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gDAAgD;EAChD,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;AAClC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,0CAA0C;EAC1C,oEAAoE;EACpE,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;EAME,gDAAgD;EAChD,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,oEAAoE;AACtE;AACA;;;;EAIE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;AACA;;EAEE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,wCAAwC;AAC1C;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gDAAgD;EAChD,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kCAAkC;AACpC;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,4CAA4C;AAC9C;AACA;;EAEE,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,yCAAyC;IACzC,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,+BAA+B;IAC/B,4BAA4B;IAC5B,4BAA4B;IAC5B,0DAA0D;EAC5D;EACA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,0CAA0C;EAC5C;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,oCAAoC;EACtC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,0CAA0C;IAC1C,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,QAAQ;IACR,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,+CAA+C;AAC/C;EACE,WAAW;AACb;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,+CAA+C;AACjD;AACA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,kEAAkE;EAClE,gEAAgE;AAClE;AACA;EACE,yDAAyD;EACzD,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,oCAAoC;EACpC,mBAAmB;AACrB;AACA;;;;;;;;;;EAUE,uCAAuC;EACvC,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;AACA;;;EAGE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,wDAAwD;AAC1D;AACA;;EAEE,SAAS;EACT,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;AACA;;;;;EAKE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,SAAO;EACP,SAAS;EACT,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;AACA;;;EAGE,uBAAkB;EAAlB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,mDAAmD;EACnD,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;AACA;;EAEE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,SAAO;EACP,SAAS;EACT,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;EACvC,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,4BAA4B;EAC5B,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,+CAA+C;AACjD;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;;;EAGE,uCAAuC;EACvC,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;;EAEE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;;EAEE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,SAAS;EACT,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;EACvC,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,wEAAwE;AAC1E;AACA;EACE,4CAA4C;EAC5C,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,0CAA0C;EAC1C,+CAA+C;EAC/C,UAAU;EACV,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,QAAQ;EACR,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,iDAAiD;AACnD;AACA;EACE,YAAY;EACZ,SAAO;EACP,SAAS;EACT,UAAU;EACV,UAAU;EACV,0BAA0B;EAC1B,uBAAuB;EACvB,wEAAwE;AAC1E;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,4BAA4B;EAC5B,oCAAoC;EACpC,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,+CAA+C;AACjD;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0CAA0C;EAC1C,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;AACA;;;;EAIE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;EACjC,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qDAAqD;EACrD,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,sDAAsD;AACxD;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;AACA;EACE,SAAO;AACT;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,4CAA4C;EAC5C,aAAa;AACf;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,0CAA0C;AAC5C;AACA;EACE,SAAO;EACP,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,0DAA0D;AAC5D;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,0BAA0B;EAC1B,2DAA2D;EAC3D,6EAA6E;AAC/E;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,6CAA6C;AAC/C;AACA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,uDAAuD;EACvD,sEAAsE;EACtE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,gDAAgD;EAClD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,oDAAoD;IACpD,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,QAAQ;IACR,eAAe;IACf,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,sBAAsB;EACxB;EACA;;;;IAIE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,oBAAoB;IACpB,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;;IAEE,SAAO;EACT;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;IAChB,4BAA4B;IAC5B,4BAA4B;IAC5B,2CAA2C;EAC7C;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;;;IAGE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,QAAQ;IACR,qCAAqC;IACrC,eAAe;IACf,6DAA6D;IAC7D,eAAe;IACf,2CAA2C;IAC3C,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;IAC/B,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,SAAS;IACT,4BAA4B;IAC5B,aAAa;IACb;2CACuC;EACzC;EACA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,0CAA0C;IAC1C,wEAAwE;EAC1E;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,SAAW;IACX,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":[".settings-page {\n  min-height: 100vh;\n  background: var(--bg-primary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n\n.settings-main {\n  min-width: 0;\n}\n.settings-content {\n  padding: 24px 32px 40px;\n}\n.settings-content > h1 {\n  margin: 0 0 8px;\n  font-size: 32px;\n  line-height: 40px;\n  font-weight: 600;\n  letter-spacing: -0.48px;\n}\n.settings-tabs {\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  margin-bottom: 24px;\n}\n.settings-tabs button {\n  position: relative;\n  border: 0;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  padding: 10px 16px;\n  white-space: nowrap;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n  cursor: pointer;\n}\n.settings-tabs button.active {\n  color: var(--interactive-default, #0f766e);\n}\n.settings-tabs button.active::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -1px;\n  height: 2px;\n  background: var(--interactive-default, #0f766e);\n}\n.settings-section-heading {\n  margin-bottom: 16px;\n}\n.settings-section-heading h2,\n.settings-card h3 {\n  margin: 0;\n  font-weight: 500;\n}\n.settings-section-heading h2 {\n  font-size: 28px;\n  line-height: 36.4px;\n  font-weight: 600;\n  letter-spacing: -0.28px;\n}\n.settings-section-heading p,\n.settings-card p {\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.settings-section-heading p {\n  font-size: 16px;\n  line-height: 25.6px;\n  letter-spacing: 0;\n}\n.settings-section-heading p {\n  margin: 2px 0 0;\n}\n.settings-card {\n  background: var(--surface-primary, #fff);\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  padding: 24px;\n  margin-bottom: 16px;\n}\n.settings-card h3 {\n  font-size: 16px;\n  line-height: 20.8px;\n  letter-spacing: 0;\n}\n.settings-photo-row,\n.settings-security-card,\n.settings-team-links,\n.settings-heading-action {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n.settings-photo-row {\n  justify-content: flex-start;\n  margin-top: 14px;\n}\n.settings-photo-row img,\n.settings-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--border-subtle, #dce3e2);\n}\n.settings-avatar {\n  display: grid;\n  place-items: center;\n  color: var(--interactive-default, #0f766e);\n  background: var(--interactive-soft, #f0f8f7);\n  font-weight: 600;\n}\n.settings-photo-row p {\n  margin: 0 0 10px;\n}\n.settings-button {\n  display: inline-flex;\n  width: auto;\n  height: 44px;\n  min-height: 44px;\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-md, 10px);\n  padding: 0 16px;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: normal;\n  letter-spacing: 0;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.settings-button.primary {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n}\n.settings-button.secondary {\n  border: 1px solid var(--border-default, #cdd6d4);\n  color: var(--text-primary, #142624);\n  background: var(--surface-primary, #fff);\n}\n.settings-button svg,\n.plan-billing-button svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 auto;\n}\n.settings-button.primary:hover:not(:disabled) {\n  border-color: var(--interactive-hover, var(--interactive-default, #0f766e));\n  background: var(--interactive-hover, var(--interactive-default, #0f766e));\n}\n.settings-button.secondary:hover:not(:disabled) {\n  border-color: var(--border-strong, #aebab8);\n  background: var(--surface-secondary, #f4f7f7);\n}\n.settings-button:focus-visible,\n.plan-billing-button:focus-visible,\n.plan-billing-back:focus-visible,\n.plan-navigation-grid button:focus-visible,\n.plan-usage-grid button:focus-visible,\n.available-plan-heading button:focus-visible,\n.plan-history-table button:focus-visible,\n.plan-cancel-link:focus-visible {\n  outline: 2px solid var(--focus-ring, #8bcfc7);\n  outline-offset: 2px;\n}\n.settings-button:disabled {\n  border-color: var(--border-subtle, #dce3e2);\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-disabled, #8a9896);\n  cursor: not-allowed;\n}\n.settings-photo-card .settings-button {\n  width: auto;\n  height: 40px;\n  min-height: 40px;\n  gap: 6px;\n  padding: 0 12px;\n  font-size: 13px;\n}\n.settings-card-copy {\n  margin: 12px 0 16px;\n}\n.settings-detail-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px 20px;\n}\n.settings-detail-grid.bordered {\n  margin-top: 22px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.settings-detail-grid .wide {\n  grid-column: 1 / -1;\n}\n.settings-detail-grid div {\n  min-height: 64px;\n}\n.settings-detail-grid span,\n.settings-role-row span,\n.settings-business-logo span,\n.settings-card > span {\n  display: block;\n  font-size: 13px;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n  margin-bottom: 6px;\n}\n.settings-detail-grid strong {\n  display: block;\n  min-height: 42px;\n  padding: 11px 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 25.6px;\n  letter-spacing: 0;\n}\n.settings-business-card .settings-detail-grid input,\n.settings-business-card .settings-detail-grid select {\n  width: 100%;\n  height: 40px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  outline: 0;\n  padding: 0 12px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 14px/18.2px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.settings-business-card .settings-detail-grid input:focus,\n.settings-business-card .settings-detail-grid select:focus {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.settings-business-organisation-select .quotation-figma-dropdown-trigger {\n  border-radius: var(--radius-md, 10px);\n  font-size: 14px;\n  line-height: 18.2px;\n}\n.settings-business-card .settings-detail-grid input[readonly] {\n  color: var(--text-disabled, #8a9896);\n  background: var(--surface-secondary, #f4f7f7);\n}\n.settings-business-card .settings-card-actions {\n  gap: 10px;\n}\n.settings-role-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 12px;\n}\n.settings-role-row p {\n  margin: 2px 0;\n}\n.settings-role-row b {\n  align-self: center;\n  color: var(--interactive-default, #0f766e);\n  background: var(--interactive-soft, #f0f8f7);\n  border-radius: 999px;\n  padding: 5px 10px;\n  font-size: 12px;\n}\n.settings-card-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n.settings-security-card p {\n  margin: 2px 0 0;\n}\n.settings-password-flow {\n  width: 100%;\n  max-width: 1120px;\n}\n.settings-password-card {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 0;\n}\n.settings-password-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.settings-password-field > span:first-child {\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: normal;\n}\n.settings-password-field > span:first-child b {\n  color: var(--danger-default, #c23a2b);\n  font-weight: inherit;\n}\n.settings-password-input {\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 40px;\n  align-items: center;\n  overflow: hidden;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n}\n.settings-password-input:focus-within {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.settings-password-field.error .settings-password-input {\n  border-color: var(--danger-default, #c23a2b);\n}\n.settings-password-input input {\n  width: 100%;\n  min-width: 0;\n  height: 100%;\n  padding: 0 44px 0 12px;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font: 400 14px / normal var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.settings-password-input input::placeholder {\n  color: var(--text-disabled, #8a9896);\n  opacity: 1;\n}\n.settings-password-input button {\n  position: absolute;\n  right: 8px;\n  display: grid;\n  width: 32px;\n  height: 32px;\n  place-items: center;\n  border: 0;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.settings-password-input svg {\n  width: 20px;\n  height: 20px;\n}\n.settings-password-field small {\n  min-height: 15px;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: normal;\n}\n.settings-password-field.error small,\n.settings-password-form-error {\n  color: var(--danger-text, #a3301f);\n}\n.settings-password-security-copy,\n.settings-password-form-error {\n  margin: 0 !important;\n  font-size: 11px !important;\n  line-height: 15.4px !important;\n  letter-spacing: 0.11px;\n}\n.settings-password-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n}\n.settings-password-actions .settings-button {\n  height: 44px;\n  min-height: 44px;\n  padding: 0 16px;\n  font-size: 14px;\n}\n.settings-password-actions .settings-button:disabled {\n  cursor: default;\n  opacity: 0.65;\n}\n.settings-photo-card,\n.settings-personal-card,\n.settings-security-card {\n  max-width: 1120px;\n  margin-bottom: 24px;\n}\n.settings-photo-card h3,\n.settings-personal-card h3,\n.settings-security-card h3,\n.settings-password-card h3 {\n  font-size: 22px;\n  line-height: 29.7px;\n  letter-spacing: -0.22px;\n}\n.settings-photo-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.settings-profile-fields {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px 20px;\n}\n.settings-profile-fields .wide {\n  grid-column: 1 / -1;\n}\n.settings-profile-fields label {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 6px;\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n}\n.settings-profile-fields input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  outline: 0;\n  padding: 0 12px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 14px / 18.2px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.settings-profile-fields input:focus {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.settings-profile-fields input[readonly] {\n  background: var(--surface-secondary, #f4f7f7);\n}\n.settings-profile-fields small {\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 15.6px;\n}\n.settings-profile-message {\n  margin: 12px 0 0 !important;\n  font-size: 12px !important;\n}\n.settings-personal-card .settings-card-actions .settings-button,\n.settings-security-card > .settings-button,\n.settings-password-actions .settings-button {\n  min-height: 44px;\n}\n.settings-photo-dialog-scrim {\n  position: fixed;\n  z-index: 1700;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  background: var(--overlay-default, rgba(15, 29, 27, 0.48));\n}\n.settings-photo-dialog {\n  width: min(520px, 100%);\n  min-height: 447px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  padding: 24px;\n  background: var(--surface-primary, #fff);\n  box-shadow: var(--shadow-lg, 0 16px 40px rgba(20, 38, 36, 0.2));\n}\n.settings-photo-dialog header {\n  display: flex;\n  height: 30px;\n  align-items: center;\n  justify-content: space-between;\n}\n.settings-photo-dialog h2 {\n  margin: 0;\n  color: var(--text-primary, #142624);\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 29.7px;\n  letter-spacing: -0.22px;\n}\n.settings-photo-dialog header button {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  place-items: center;\n  border: 0;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.settings-photo-dialog header button svg {\n  width: 20px;\n  height: 20px;\n}\n.settings-photo-dialog header button span {\n  display: none;\n}\n.settings-photo-dialog-body {\n  display: flex;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n.settings-photo-dialog-body > p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.settings-photo-dialog-preview {\n  min-height: 220px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 8px;\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-secondary, #f4f7f7);\n  text-align: center;\n}\n.settings-photo-dialog-preview strong {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 24px;\n}\n.settings-photo-dialog-preview > img {\n  width: 104px;\n  height: 104px;\n  border: 2px solid var(--border-subtle, #dce3e2);\n  border-radius: 50%;\n  object-fit: cover;\n}\n.settings-photo-dialog-preview small,\n.settings-photo-dialog-note {\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 15.4px;\n  letter-spacing: 0.11px;\n}\n.settings-photo-dialog .settings-photo-choose {\n  width: 100%;\n  min-height: 44px;\n  border: 0;\n  cursor: pointer;\n}\n.settings-photo-dialog-error {\n  margin: -8px 0 0 !important;\n  color: var(--danger-text, #a3301f) !important;\n  font-size: 12px !important;\n}\n.settings-photo-dialog-actions {\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: flex-end;\n  gap: 12px;\n}\n.settings-photo-dialog-actions .settings-button {\n  min-height: 44px;\n  cursor: pointer;\n}\n.settings-business-logo {\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n  gap: 0;\n}\n.settings-business-logo em {\n  color: var(--text-tertiary, #6b7b78);\n  font-style: normal;\n  font-weight: 400;\n  margin-left: 6px;\n}\n.settings-business-logo p {\n  margin: 4px 0 0;\n}\n.settings-business-logo-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n.settings-business-logo i {\n  width: 48px;\n  height: 48px;\n  display: grid;\n  place-items: center;\n  border-radius: 10px;\n  background: var(--interactive-default, #0f766e);\n  color: #fff;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n}\n.settings-business-logo-controls > img {\n  width: 48px;\n  height: 48px;\n  flex: 0 0 48px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f7);\n  object-fit: contain;\n}\n.settings-business-logo-placeholder {\n  display: grid;\n  width: 104px;\n  height: 104px;\n  place-items: center;\n  border-radius: 12px;\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n  font-size: 20px;\n  font-weight: 600;\n}\n.settings-business-logo-dialog .settings-photo-dialog-preview > img {\n  border-radius: 12px;\n  object-fit: contain;\n}\n.settings-business-logo .settings-logo-action {\n  min-width: 106px;\n  height: 36px;\n  min-height: 36px;\n  padding: 0 12px;\n  font-size: 13px;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n}\n.settings-business-logo .settings-logo-action svg,\n.settings-business-logo .settings-logo-remove svg {\n  width: 16px;\n  height: 16px;\n}\n.settings-business-logo .settings-logo-remove {\n  min-width: 104px;\n  height: 36px;\n  min-height: 36px;\n  padding: 0 12px;\n  border: 0;\n  background: transparent;\n  color: var(--danger-text, #a3301f);\n  font-size: 13px;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n  cursor: pointer;\n}\n.settings-business-logo .settings-logo-remove:hover {\n  background: var(--danger-soft, #fff2ef);\n}\n.settings-business-logo .settings-logo-remove:disabled {\n  cursor: default;\n  opacity: 0.55;\n}\n.settings-business-logo-recommendation {\n  margin-top: 8px !important;\n  color: var(--text-secondary, #506360);\n  font-size: 13px !important;\n  line-height: 18.2px !important;\n  letter-spacing: 0.065px;\n}\n.settings-business-skeleton {\n  pointer-events: none;\n}\n.settings-business-skeleton-logo {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.settings-business-skeleton-logo > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.settings-business-skeleton-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px 20px;\n}\n.settings-business-skeleton-grid.bordered {\n  padding: 20px 0 0;\n}\n.settings-business-skeleton-grid > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 8px;\n}\n.settings-business-skeleton-grid > .wide,\n.settings-business-skeleton-grid.bordered > div:last-child {\n  grid-column: 1 / -1;\n}\n.settings-business-skeleton-subheading {\n  margin: 22px 0 14px;\n}\n.settings-business-skeleton-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n@media (max-width: 767px) {\n  .settings-business-skeleton-grid {\n    grid-template-columns: 1fr;\n  }\n  .settings-business-skeleton-grid > .wide,\n  .settings-business-skeleton-grid.bordered > div:last-child {\n    grid-column: auto;\n  }\n  .settings-business-skeleton-logo > .app-skeleton {\n    max-width: 100%;\n  }\n}\n.settings-subheading {\n  margin: 20px 0 12px !important;\n}\n.settings-empty {\n  min-height: 555px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n.settings-empty > span {\n  width: 56px;\n  height: 56px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  color: var(--interactive-default, #0f766e);\n  background: var(--interactive-soft, #f0f8f7);\n  font-size: 30px;\n}\n.settings-empty h3 {\n  margin-top: 14px;\n}\n.settings-empty p {\n  max-width: 440px;\n  margin: 4px 0 14px;\n}\n.settings-plan small {\n  color: var(--interactive-default, #0f766e);\n  font-weight: 600;\n  letter-spacing: 0.8px;\n}\n.settings-plan h3 {\n  margin: 8px 0;\n  font-size: 24px;\n}\n.settings-plan p {\n  margin: 12px 0 0;\n}\n.settings-stat-grid,\n.settings-link-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n.settings-stat-grid.two {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.settings-stat-grid .settings-card svg {\n  color: var(--interactive-default, #0f766e);\n  font-size: 20px;\n}\n.settings-stat-grid h3 {\n  margin-top: 8px;\n  font-size: 22px;\n}\n.settings-link-grid .settings-card {\n  min-height: 145px;\n  display: flex;\n  flex-direction: column;\n}\n.settings-link-grid p {\n  flex: 1;\n}\n.settings-link-grid a,\n.settings-team-tabs a {\n  color: var(--interactive-default, #0f766e);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n}\n.settings-team-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n.settings-team-tabs a {\n  padding: 10px 12px;\n  border-bottom: 2px solid var(--interactive-default, #0f766e);\n}\n.settings-team-links > svg {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  color: var(--interactive-default, #0f766e);\n}\n.settings-team-links > div {\n  flex: 1;\n}\n.settings-team-links p {\n  margin: 3px 0 0;\n}\n.settings-responsive-context {\n  display: none;\n}\n.settings-team-workspace {\n  position: relative;\n}\n.settings-heading-action .settings-button {\n  cursor: pointer;\n}\n.settings-team-tabs {\n  display: flex;\n  gap: 0;\n  margin-bottom: 16px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  width: max-content;\n}\n.settings-team-tabs button {\n  position: relative;\n  min-height: 40px;\n  padding: 0 12px;\n  border: 0;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n  cursor: pointer;\n}\n.settings-team-tabs button.active {\n  color: var(--interactive-default, #0f766e);\n}\n.settings-team-tabs button.active::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: -1px;\n  left: 0;\n  height: 2px;\n  background: var(--interactive-default, #0f766e);\n}\n.settings-team-stats {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n.settings-team-stats section {\n  display: flex;\n  min-height: 116px;\n  flex-direction: column;\n  justify-content: center;\n  padding: 20px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n}\n.settings-team-stats span,\n.settings-team-stats small {\n  color: var(--text-secondary, #506360);\n}\n.settings-team-stats span {\n  font-size: 14px;\n  line-height: 21.7px;\n  letter-spacing: 0;\n}\n.settings-team-stats small {\n  font-size: 12px;\n  line-height: 16.8px;\n  letter-spacing: 0.12px;\n}\n.settings-team-stats strong {\n  margin: 4px 0 2px;\n  font-size: 28px;\n  line-height: 36.4px;\n  font-weight: 600;\n  letter-spacing: -0.28px;\n}\n.settings-team-stat-skeleton > :is(span, strong, small) {\n  display: flex;\n  align-items: center;\n  min-height: 1lh;\n}\n.settings-team-stat-skeleton strong > .app-skeleton {\n  font: inherit;\n  height: 1em;\n}\n.settings-team-table-card,\n.settings-team-form-card {\n  margin-bottom: 16px;\n  overflow: visible;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n}\n.settings-team-table-card > header {\n  display: flex;\n  min-height: 56px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n}\n.settings-team-table-card h3,\n.settings-team-form-card h3 {\n  margin: 0;\n  font-size: 22px;\n  line-height: 29.7px;\n  font-weight: 500;\n  letter-spacing: -0.22px;\n}\n.settings-team-table-card > header span {\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 21.7px;\n  letter-spacing: 0;\n}\n.settings-team-table-scroll {\n  overflow-x: auto;\n}\n.settings-team-table-card table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n.settings-team-table-card th,\n.settings-team-table-card td {\n  height: 52px;\n  padding: 0 20px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n  text-align: left;\n  font-size: 14px;\n  line-height: 21.7px;\n  letter-spacing: 0;\n  font-weight: 400;\n}\n.settings-team-table-card th {\n  height: 44px;\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 18.2px;\n  font-weight: 500;\n  letter-spacing: 0.07px;\n}\n.settings-team-table-card tbody tr:nth-child(even) {\n  background: var(--interactive-soft, #f0f8f7);\n}\n.settings-member-name {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.settings-member-name i,\n.settings-member-summary > i {\n  display: grid;\n  width: 26px;\n  height: 26px;\n  flex: 0 0 auto;\n  place-items: center;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 50%;\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n  font-size: 10px;\n  font-style: normal;\n}\n.settings-status {\n  display: inline-flex;\n  min-height: 24px;\n  align-items: center;\n  padding: 0 8px;\n  border-radius: 999px;\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.settings-status.active {\n  background: var(--success-soft, #f0fdf4);\n  color: var(--success-text, #15803d);\n}\n.settings-status.pending {\n  background: var(--warning-soft, #fef8ec);\n  color: var(--warning-text, #7d4412);\n}\n.settings-status.inactive {\n  background: var(--danger-soft, #fef2f2);\n  color: var(--danger-text, #b42318);\n}\n.settings-action-cell {\n  position: relative;\n  width: 100px;\n  text-align: center !important;\n}\n.settings-action-heading {\n  text-align: center !important;\n}\n.settings-action-cell > button {\n  display: inline-grid;\n  width: 32px;\n  height: 32px;\n  place-items: center;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n.settings-action-cell > button:hover {\n  background: var(--surface-tertiary, #e8edec);\n}\n.settings-action-cell > button:focus-visible,\n.reminder-row > button:focus-visible,\n.settings-tabs button:focus-visible,\n.settings-team-tabs button:focus-visible {\n  outline: 2px solid var(--focus-ring, #8bcfc7);\n  outline-offset: 2px;\n}\n.settings-action-menu {\n  position: absolute;\n  z-index: 20;\n  top: 42px;\n  right: 16px;\n  width: 160px;\n  padding: 6px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 10px 28px rgba(20, 38, 36, 0.14);\n}\n.settings-action-menu button {\n  width: 100%;\n  padding: 9px 10px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n}\n.settings-action-menu button:hover {\n  background: var(--surface-secondary, #f4f7f7);\n}\n.settings-action-menu button.danger {\n  color: var(--danger-text, #a3301f);\n}\n.settings-team-empty-row,\n.settings-team-empty-pending {\n  color: var(--text-secondary, #506360);\n  text-align: center !important;\n}\n.settings-team-empty-row svg {\n  margin-right: 8px;\n}\n.settings-team-empty-pending {\n  display: grid;\n  min-height: 170px;\n  place-items: center;\n  align-content: center;\n  gap: 4px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.settings-team-empty-pending svg {\n  margin-bottom: 6px;\n  font-size: 28px;\n  color: var(--interactive-default, #0f766e);\n}\n.settings-team-empty-pending p {\n  margin: 0;\n  font-size: 13px;\n}\n.settings-team-form-card {\n  padding: 24px;\n}\n.settings-team-form-card > h3 {\n  margin-bottom: 18px;\n}\n.settings-team-form-card label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n}\n.settings-team-form-card label b {\n  color: var(--danger-text, #a3301f);\n}\n.settings-team-form-card input,\n.settings-team-form-card select {\n  width: 100%;\n  height: 42px;\n  margin-top: 6px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  outline: none;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 14px/20px inherit;\n}\n.settings-team-form-card select {\n  appearance: none;\n  padding-right: 38px;\n}\n.settings-team-form-card input:focus,\n.settings-team-form-card select:focus {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.settings-team-form-card input.error,\n.settings-team-form-card select.error {\n  border-color: var(--danger-text, #a3301f);\n}\n.settings-team-form-card label small {\n  display: block;\n  min-height: 17px;\n  margin-top: 4px;\n  color: var(--text-secondary, #506360);\n  font-weight: 400;\n}\n.settings-team-form-card input.error + small,\n.settings-team-form-card .settings-role-permission-select:has(.error) + small,\n.settings-team-form-card .settings-select-wrap:has(select.error) + small {\n  color: var(--danger-text, #a3301f);\n}\n.settings-select-wrap {\n  position: relative;\n  display: block;\n}\n.settings-select-wrap > svg {\n  position: absolute;\n  top: 19px;\n  right: 12px;\n  pointer-events: none;\n}\n.settings-team-form-card > p,\n.settings-role-access > p {\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n}\n.settings-team-form-card footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.settings-team-form-card footer button {\n  cursor: pointer;\n}\n.settings-member-summary {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n  padding: 14px;\n  border-radius: 8px;\n  background: var(--surface-secondary, #f4f7f7);\n}\n.settings-member-summary > i {\n  width: 40px;\n  height: 40px;\n}\n.settings-member-summary div {\n  display: flex;\n  flex-direction: column;\n}\n.settings-member-summary span {\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n}\n.settings-role-fields,\n.settings-access-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0 20px;\n}\n.settings-member-access-fields {\n  margin-top: var(--space-4, 16px);\n}\n.settings-role-access {\n  margin-top: 4px;\n  padding-top: 18px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.settings-access-grid {\n  margin-top: 14px;\n}\n.settings-role-permission-select {\n  margin-top: 0;\n}\n.settings-role-permission-select .quotation-figma-dropdown-trigger {\n  height: 40px;\n  padding: 0 12px;\n  border-color: var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  font-size: 14px;\n}\n.settings-module-access-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px 20px;\n  margin-top: var(--space-4, 16px);\n}\n.settings-role-form label.settings-module-access-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  margin: 0;\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: 500;\n}\n.settings-module-access-field .quotation-figma-dropdown-trigger > span {\n  color: var(--text-primary, #142624);\n  font-weight: 400;\n}\n.settings-module-access-field .quotation-figma-dropdown-trigger:disabled > span,\n.settings-module-access-field .quotation-figma-dropdown-trigger > span:empty {\n  color: var(--text-disabled, #8a9896);\n}\n.settings-role-form-body {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n.settings-role-form-body > h3 {\n  margin-bottom: var(--space-4, 16px);\n}\n.settings-role-form .settings-module-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  max-width: 400px;\n  margin: var(--space-4, 16px) 0;\n}\n.settings-module-search > svg {\n  position: absolute;\n  left: 12px;\n  color: var(--text-secondary);\n  pointer-events: none;\n}\n.settings-role-form .settings-module-search input {\n  margin: 0;\n  padding: 0 40px;\n}\n.settings-permission-group {\n  margin-top: var(--space-3, 12px);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md, 10px);\n}\n.settings-permission-group h4 {\n  margin: 0;\n}\n.settings-permission-group h4 button {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3, 12px);\n  width: 100%;\n  min-height: 48px;\n  padding: var(--space-3, 12px) var(--space-4, 16px);\n  border: 0;\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n  font: inherit;\n  font-size: 14px;\n  text-align: left;\n  cursor: pointer;\n}\n.settings-permission-group h4 button small {\n  margin-left: auto;\n  color: var(--text-secondary);\n  font-size: 12px;\n  font-weight: 400;\n}\n.settings-permission-group h4 button svg {\n  flex-shrink: 0;\n}\n.settings-permission-group h4 button[aria-expanded=\"true\"] svg {\n  transform: rotate(180deg);\n}\n.settings-permission-group h4 button:hover:not(:disabled) {\n  background: var(--surface-hover, var(--surface-primary));\n}\n.settings-permission-group h4 button:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n.settings-role-form label.settings-module-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 180px;\n  align-items: center;\n  gap: var(--space-4, 16px);\n  margin: 0;\n  padding: var(--space-2, 8px) var(--space-4, 16px);\n  border-top: 1px solid var(--border-subtle);\n  font-size: 14px;\n}\n.settings-module-row > span {\n  overflow-wrap: anywhere;\n}\n.settings-module-row .settings-role-permission-select {\n  min-width: 0;\n  margin: 0;\n}\n.settings-module-empty {\n  padding: var(--space-4, 16px);\n  background: var(--surface-secondary);\n  border-radius: var(--radius-md, 10px);\n}\n.settings-role-form footer.settings-role-actions {\n  position: sticky;\n  bottom: 0;\n  z-index: 5;\n  flex-wrap: wrap;\n  margin: var(--space-4, 16px) -24px -24px;\n  padding: var(--space-4, 16px) 24px\n    max(var(--space-4, 16px), env(safe-area-inset-bottom));\n  background: var(--surface-primary);\n  border-radius: 0 0 var(--radius-md, 10px) var(--radius-md, 10px);\n}\n.settings-role-actions .settings-form-alert {\n  flex-basis: 100%;\n  margin: 0;\n}\n.settings-role-saving {\n  animation: settings-role-spin 1s linear infinite;\n}\n@keyframes settings-role-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .settings-role-saving {\n    animation: none;\n  }\n}\n@media (max-width: 640px) {\n  .settings-role-form label.settings-module-row {\n    grid-template-columns: minmax(0, 1fr) minmax(130px, 45%);\n    gap: var(--space-2, 8px);\n    padding: var(--space-2, 8px);\n    font-size: 12px;\n  }\n  .settings-permission-group h4 button {\n    padding: var(--space-3, 12px) var(--space-2, 8px);\n    gap: var(--space-2, 8px);\n  }\n}\n.settings-form-alert {\n  margin-bottom: 14px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: var(--danger-soft, #fef2f1);\n  color: var(--danger-text, #a3301f);\n  font-size: 13px;\n}\n.settings-member-choice {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n.settings-member-choice > button {\n  display: grid;\n  grid-template-columns: 32px minmax(0, 1fr);\n  gap: 4px 12px;\n  min-height: 116px;\n  padding: 18px;\n  border: 1px solid var(--border-default, #cad5d3);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  text-align: left;\n  cursor: pointer;\n}\n.settings-member-choice > button:hover,\n.settings-member-choice > button:focus-visible {\n  border-color: var(--interactive-default, #0f8178);\n}\n.settings-member-choice > button > svg {\n  grid-row: 1 / 3;\n  width: 24px;\n  height: 24px;\n  color: var(--interactive-default, #0f8178);\n}\n.settings-member-choice > button > span {\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18px;\n}\n.settings-member-choice > footer {\n  grid-column: 1 / -1;\n}\n.settings-existing-destination {\n  margin: 0 0 16px;\n  padding: 12px 14px;\n  border-radius: 8px;\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-secondary, #506360);\n}\n.settings-existing-member-loading {\n  display: grid;\n  gap: 16px;\n}\n@media (max-width: 640px) {\n  .settings-member-choice {\n    grid-template-columns: 1fr;\n  }\n  .settings-member-choice > footer {\n    grid-column: auto;\n  }\n}\n.settings-page.dark {\n  --bg-primary: #101113;\n  --surface-primary: #191b1f;\n  --text-primary: #f2f3f5;\n  --text-secondary: #b3b8c2;\n  --border-default: #3a3f47;\n  --border-subtle: #2c3036;\n  --border-strong: #555d68;\n  --interactive-default: #43a79c;\n  --interactive-hover: #56b9ae;\n  --interactive-soft: #22252a;\n  --on-interactive-primary: #101113;\n  --focus-ring: #73c9c0;\n  --text-disabled: #747b86;\n  --surface-secondary: #22252a;\n  --surface-tertiary: #2b2f35;\n  --success-soft: #1b332b;\n  --success-text: #8cd2b2;\n  --warning-soft: #3b2e19;\n  --warning-text: #e5c17d;\n  --danger-soft: #382324;\n  --danger-text: #f3a6a1;\n}\n@media (max-width: 900px) {\n  .settings-content {\n    padding: 24px;\n  }\n  .settings-responsive-context {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 61px;\n  }\n  .settings-product-identity {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: var(--text-secondary, #506360);\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 16.9px;\n  }\n  .settings-product-identity button {\n    display: grid;\n    width: 44px;\n    height: 44px;\n    place-items: center;\n    padding: 0;\n    border: 1px solid var(--border-subtle, #dce3e2);\n    border-radius: 10px;\n    color: var(--text-primary, #142624);\n    background: var(--surface-primary, #fff);\n    cursor: pointer;\n  }\n  .settings-product-identity button svg {\n    width: 20px;\n    height: 20px;\n  }\n  .settings-organisation-selector {\n    display: flex;\n    width: 220px;\n    min-width: 0;\n    align-items: center;\n    gap: 8px;\n    padding: 12px;\n    border: 1px solid var(--border-subtle, #dce3e2);\n    border-radius: 10px;\n    background: var(--surface-primary, #fff);\n  }\n  .settings-organisation-selector > i {\n    display: grid;\n    width: 32px;\n    height: 32px;\n    flex: 0 0 auto;\n    place-items: center;\n    border: 1.5px solid var(--border-subtle, #dce3e2);\n    border-radius: 50%;\n    color: var(--interactive-default, #0f766e);\n    background: var(--interactive-soft, #f0f8f7);\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n  }\n  .settings-organisation-selector > span {\n    display: flex;\n    min-width: 0;\n    flex: 1;\n    flex-direction: column;\n    gap: 4px;\n  }\n  .settings-organisation-selector strong,\n  .settings-organisation-selector small {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .settings-organisation-selector strong {\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 16.9px;\n  }\n  .settings-organisation-selector small {\n    color: var(--text-secondary, #506360);\n    font-size: 11px;\n    line-height: 15.4px;\n  }\n  .settings-organisation-selector > svg {\n    width: 16px;\n    height: 16px;\n    flex: 0 0 auto;\n    color: var(--interactive-default, #0f766e);\n  }\n  .settings-tabs {\n    overflow: hidden;\n  }\n  .settings-stat-grid,\n  .settings-role-fields,\n  .settings-access-grid,\n  .settings-module-access-grid {\n    grid-template-columns: 1fr;\n  }\n  .settings-link-grid {\n    grid-template-columns: 1fr;\n  }\n  .settings-empty {\n    min-height: calc(100vh - 291px);\n  }\n  .settings-content > h1 {\n    margin-top: 16px;\n    font-size: 28px;\n    line-height: 35px;\n    letter-spacing: -0.42px;\n  }\n  .settings-section-heading h2 {\n    font-size: 24px;\n    line-height: 31.2px;\n    letter-spacing: -0.24px;\n  }\n  .settings-card h3 {\n    font-size: 20px;\n    line-height: 27px;\n    letter-spacing: -0.2px;\n  }\n  .settings-photo-card {\n    padding: 20px 24px;\n  }\n  .settings-plan h3 {\n    font-size: 24px;\n    line-height: 31.2px;\n  }\n  .settings-stat-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n@media (max-width: 640px) {\n  html:has(.settings-page),\n  body:has(.settings-page) {\n    height: auto;\n    min-height: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n  body:has(.settings-role-form) {\n    overflow-x: clip;\n    overflow-y: visible;\n  }\n  .settings-page,\n  .settings-main,\n  .settings-panel,\n  .plan-billing-workspace {\n    height: auto;\n    min-height: 0;\n    overflow: visible;\n  }\n  .settings-page,\n  .settings-main {\n    min-height: 100dvh;\n  }\n  .settings-content {\n    min-height: calc(100dvh - 64px);\n    overflow: visible;\n    padding: 20px 16px calc(96px + env(safe-area-inset-bottom));\n  }\n  .settings-content > h1 {\n    margin: 16px 0 0;\n    font-size: 24px;\n    line-height: 30px;\n    letter-spacing: -0.36px;\n  }\n  .settings-responsive-context {\n    min-height: 61px;\n  }\n  .settings-product-identity {\n    display: none;\n  }\n  .settings-organisation-selector {\n    width: 100%;\n  }\n  .settings-tabs {\n    display: flex;\n    width: calc(100% + 16px);\n    height: 37px;\n    gap: 0;\n    margin: 16px -16px 20px 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n    border-bottom: 0;\n    padding: 0;\n    scrollbar-width: none;\n    -webkit-overflow-scrolling: touch;\n  }\n  .settings-tabs::-webkit-scrollbar {\n    display: none;\n  }\n  .settings-tabs button {\n    width: auto;\n    min-width: max-content;\n    height: 37px;\n    flex: 0 0 auto;\n    overflow: visible;\n    padding: 10px 16px;\n    text-overflow: clip;\n  }\n  .settings-tabs button.active::after {\n    bottom: 0;\n  }\n  .settings-tabs.mobile-billing-first button:nth-child(1) {\n    order: 4;\n  }\n  .settings-tabs.mobile-billing-first button:nth-child(2) {\n    order: 5;\n  }\n  .settings-tabs.mobile-billing-first button:nth-child(3) {\n    order: 6;\n  }\n  .settings-tabs.mobile-billing-first button:nth-child(4) {\n    order: 1;\n  }\n  .settings-tabs.mobile-billing-first button:nth-child(5) {\n    order: 2;\n  }\n  .settings-tabs.mobile-billing-first button:nth-child(6) {\n    order: 3;\n  }\n  .settings-section-heading {\n    margin: 0 0 16px;\n  }\n  .settings-section-heading h2 {\n    font-size: 20px;\n    line-height: 26px;\n    letter-spacing: -0.2px;\n  }\n  .settings-section-heading p {\n    margin-top: 4px;\n    font-size: 13px;\n    line-height: 20.2px;\n    letter-spacing: 0;\n  }\n  .settings-password-flow {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n  .settings-password-flow .settings-section-heading {\n    margin-bottom: 0;\n  }\n  .settings-password-card {\n    gap: 16px;\n    padding: 16px;\n  }\n  .settings-password-card h3 {\n    font-size: 18px;\n    line-height: 24.3px;\n    letter-spacing: -0.18px;\n  }\n  .settings-password-security-copy {\n    max-width: 310px;\n  }\n  .settings-card {\n    padding: 16px;\n    margin-bottom: 14px;\n  }\n  .settings-card h3 {\n    font-size: 18px;\n    line-height: 24.3px;\n    letter-spacing: -0.18px;\n  }\n  .settings-detail-grid,\n  .settings-stat-grid,\n  .settings-stat-grid.two {\n    grid-template-columns: 1fr;\n  }\n  .settings-team-stats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .settings-detail-grid .wide {\n    grid-column: auto;\n  }\n  .settings-business-card .settings-detail-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .settings-business-card {\n    padding: 16px;\n  }\n  .settings-business-logo {\n    min-height: 147px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  }\n  .settings-business-logo-copy > span {\n    margin-bottom: 0;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 16.9px;\n    letter-spacing: 0.065px;\n  }\n  .settings-business-logo-copy > p {\n    margin-top: 8px;\n    font-size: 13px;\n    line-height: 18.2px;\n    letter-spacing: 0.065px;\n  }\n  .settings-business-logo-controls {\n    margin-top: 8px;\n  }\n  .settings-business-logo-recommendation {\n    max-width: 326px;\n  }\n  .settings-business-card .settings-detail-grid.bordered {\n    margin-top: 16px;\n    padding-top: 0;\n    border-top: 0;\n  }\n  .settings-business-card .settings-subheading {\n    margin: 16px 0 12px !important;\n    font-size: 16px;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n  }\n  .settings-business-card .settings-detail-grid .wide,\n  .settings-business-card .settings-detail-grid.bordered > div:last-child {\n    grid-column: 1 / -1;\n  }\n  .settings-photo-row,\n  .settings-team-links,\n  .settings-heading-action {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .settings-photo-row {\n    align-items: center;\n    gap: 16px;\n    margin-top: 16px;\n    text-align: center;\n  }\n  .settings-photo-row > div {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  }\n  .settings-photo-row p {\n    width: 100%;\n    max-width: 324px;\n    margin: 0 0 8px;\n    font-size: 13px;\n    line-height: 20.2px;\n    letter-spacing: 0;\n    text-align: center;\n  }\n  .settings-photo-card {\n    min-height: 244px;\n    padding: 16px;\n  }\n  .settings-photo-card h3 {\n    font-size: 18px;\n    line-height: 24.3px;\n    letter-spacing: -0.18px;\n  }\n  .settings-photo-card .settings-button {\n    min-width: 118px;\n    min-height: 40px;\n    padding: 0 13px;\n    font-size: 13px;\n    line-height: normal;\n    letter-spacing: 0;\n  }\n  .settings-button {\n    width: auto;\n    height: 40px;\n    min-height: 40px;\n    gap: 6px;\n    padding: 0 12px;\n    font-size: 13px;\n    line-height: normal;\n    letter-spacing: 0;\n  }\n  .settings-card-actions {\n    display: flex;\n  }\n  .settings-heading-action .settings-button {\n    width: auto;\n  }\n  .settings-team-table-card th,\n  .settings-team-table-card td {\n    min-width: 0;\n  }\n  .settings-team-table-scroll {\n    overflow: visible;\n  }\n  .settings-team-table-card {\n    border: 0;\n    background: transparent;\n  }\n  .settings-team-table-card > header {\n    height: 31px;\n    padding: 0;\n    border: 0;\n    background: transparent;\n  }\n  .settings-team-table-card > header h3 {\n    font-size: 16px;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n  }\n  .settings-team-table-card > header span {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n  .settings-team-table-card table,\n  .settings-team-table-card tbody {\n    display: block;\n    width: 100%;\n  }\n  .settings-team-table-card thead {\n    display: none;\n  }\n  .settings-team-table-card tbody {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 8px;\n  }\n  .settings-team-table-card tbody tr {\n    display: grid;\n    width: 100%;\n    min-height: 98px;\n    grid-template-columns: minmax(0, 1fr) auto 40px;\n    grid-template-rows: 22px 19px 20px;\n    gap: 2px 8px;\n    align-content: center;\n    padding: 12px 16px;\n    border: 1px solid var(--border-default, #cdd6d4);\n    border-radius: 10px;\n    background: var(--surface-primary, #fff);\n  }\n  .settings-team-table-card tbody tr:nth-child(even) {\n    background: var(--surface-primary, #fff);\n  }\n  .settings-team-table-card td {\n    display: block;\n    width: auto;\n    height: auto;\n    min-height: 0;\n    padding: 0;\n    border: 0;\n    overflow: hidden;\n    font-size: 12px;\n    line-height: 20px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .settings-team-table-card td[data-label=\"Name\"] {\n    grid-area: 1 / 1;\n    color: var(--text-primary, #142624);\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 22px;\n  }\n  .settings-member-name i {\n    display: none;\n  }\n  .settings-team-table-card td[data-label=\"Role\"] {\n    grid-area: 2 / 1;\n    color: var(--interactive-default, #0f766e);\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 19px;\n    text-transform: uppercase;\n  }\n  .settings-team-table-card td[data-label=\"Email\"] {\n    grid-area: 3 / 1;\n    color: var(--text-secondary, #506360);\n    font-size: 12px;\n    line-height: 20px;\n  }\n  .settings-team-table-card td[data-label=\"Status\"] {\n    grid-area: 1 / 2;\n    overflow: visible;\n  }\n  .settings-team-table-card td[data-label=\"Actions\"] {\n    grid-area: 1 / 3;\n    overflow: visible;\n  }\n  .settings-team-table-card + .settings-team-table-card tbody tr {\n    min-height: 78px;\n    grid-template-rows: 22px 20px;\n  }\n  .settings-team-table-card + .settings-team-table-card td[data-label=\"Email\"] {\n    grid-area: 1 / 1;\n    color: var(--text-primary, #142624);\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 22px;\n  }\n  .settings-team-table-card + .settings-team-table-card td[data-label=\"Role\"] {\n    grid-area: 2 / 1;\n  }\n  .settings-action-cell {\n    width: 40px;\n    text-align: center !important;\n  }\n  .settings-action-cell > button {\n    width: 40px;\n    height: 40px;\n    margin: -9px 0 0;\n    border-radius: 10px;\n  }\n  .settings-empty {\n    min-height: 420px;\n  }\n  .settings-detail-grid {\n    gap: 12px;\n  }\n  .settings-detail-grid > div {\n    min-height: 62px;\n  }\n  .settings-detail-grid > div > span {\n    min-height: 16px;\n    margin-bottom: 6px;\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 13px;\n    font-weight: var(--font-weight-medium, 500);\n    line-height: 16px;\n    letter-spacing: 0;\n  }\n  .settings-detail-grid strong {\n    display: flex;\n    height: 40px;\n    min-height: 40px;\n    align-items: center;\n    padding: 0 12px;\n    border-radius: 10px;\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-weight: var(--font-weight-regular, 400);\n  }\n  .settings-card:not(.settings-business-card) .settings-detail-grid strong {\n    font-size: 14px;\n    line-height: normal;\n    letter-spacing: 0;\n  }\n  .settings-business-card .settings-detail-grid {\n    gap: 16px 12px;\n  }\n  .settings-business-card .settings-detail-grid > div {\n    min-height: 63px;\n  }\n  .settings-business-card .settings-detail-grid > div > span {\n    min-height: 17px;\n    line-height: 16.9px;\n    letter-spacing: 0.065px;\n  }\n  .settings-business-card .settings-detail-grid strong {\n    font-size: 13px;\n    line-height: 20.2px;\n    letter-spacing: 0;\n  }\n  .settings-business-card .settings-abn-field > span {\n    min-height: 19px;\n    font-size: 14px;\n    line-height: 18.2px;\n  }\n  .settings-role-row {\n    position: relative;\n    display: block;\n    padding-right: 72px;\n  }\n  .settings-role-row b {\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n  .settings-security-card {\n    align-items: flex-end;\n    flex-direction: column;\n    gap: 12px;\n  }\n  .settings-security-card > div {\n    width: 100%;\n  }\n}\n\n.settings-reminder-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n}\n.settings-switch {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.settings-switch input {\n  position: absolute;\n  opacity: 0;\n}\n.settings-switch span {\n  width: 40px;\n  height: 24px;\n  padding: 3px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 999px;\n  background: var(--surface-primary, #fff);\n}\n.settings-switch span::after {\n  content: \"\";\n  display: block;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--text-disabled, #8a9896);\n  transition: transform 160ms ease;\n}\n.settings-switch input:checked + span {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n}\n.settings-switch input:checked + span::after {\n  transform: translateX(16px);\n  background: var(--surface-primary, #fff);\n}\n.reminder-list {\n  max-width: 1120px;\n  padding: 0 24px;\n}\n.reminder-row {\n  display: grid;\n  grid-template-columns: 40px 1fr 40px 40px;\n  gap: 12px;\n  align-items: center;\n  min-height: 84px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.reminder-row:last-child {\n  border-bottom: 0;\n}\n.reminder-row > i {\n  display: grid;\n  width: 40px;\n  height: 40px;\n  place-items: center;\n  border-radius: 50%;\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n.reminder-row > div {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.reminder-row strong {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 24px;\n}\n.reminder-row span {\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 20.2px;\n}\n.reminder-row button {\n  display: grid;\n  width: 40px;\n  height: 40px;\n  place-items: center;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  cursor: pointer;\n}\n.settings-sheet-scrim {\n  position: fixed;\n  z-index: 1700;\n  inset: 0;\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-end;\n  background: var(--overlay-default, rgba(15, 29, 27, 0.48));\n}\n.settings-sheet {\n  width: min(520px, 100%);\n  overflow-y: auto;\n  padding: 24px;\n  background: var(--surface-primary, #fff);\n}\n.settings-sheet-handle {\n  display: none;\n}\n.settings-sheet header {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  padding-bottom: 16px;\n}\n.settings-sheet h3 {\n  margin: 0;\n  font-size: 18px;\n  line-height: 24.3px;\n}\n.settings-sheet header p {\n  margin: 4px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.settings-sheet header button {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  background: transparent;\n  color: var(--interactive-default, #0f766e);\n  cursor: pointer;\n}\n.reminder-preview-summary {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-top: 16px;\n  padding: 16px;\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f7);\n}\n.reminder-preview-summary > div {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.reminder-preview-summary span,\n.reminder-preview > p {\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 20.2px;\n}\n.reminder-preview-meta {\n  display: grid;\n  grid-template-columns: 44px 1fr;\n  gap: 14px 12px;\n  margin-top: 16px;\n  padding: 16px 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  font-size: 13px;\n}\n.reminder-preview-meta span {\n  color: var(--text-secondary, #506360);\n  font-weight: 500;\n}\n.reminder-preview-meta b {\n  font-weight: 400;\n}\n.reminder-preview article,\n.reminder-email-preview article {\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  padding: 16px;\n  font-size: 13px;\n  line-height: 20.2px;\n}\n.reminder-preview article h4 {\n  margin: 0 0 16px;\n  font-size: 16px;\n}\n.reminder-preview article aside,\n.reminder-edit-card aside {\n  border-radius: 10px;\n  padding: 12px 16px;\n  background: var(--info-soft, #eef5ff);\n  color: var(--info-text, #165dce);\n}\n.settings-inline-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 20px;\n  border: 0;\n  background: transparent;\n  color: var(--interactive-default, #0f766e);\n  font: 500 13px/17px var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.reminder-edit-card {\n  display: flex;\n  max-width: 720px;\n  flex-direction: column;\n  gap: 10px;\n}\n.reminder-edit-card > label,\n.payment-edit-card label {\n  font-size: 13px;\n  font-weight: 500;\n}\n.reminder-edit-card > input,\n.reminder-edit-card textarea,\n.reminder-timing input,\n.reminder-timing select,\n.reminder-toolbar select,\n.payment-edit-card input {\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 13px/20px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.reminder-edit-card > input,\n.reminder-timing input,\n.reminder-timing select,\n.payment-edit-card input {\n  height: 40px;\n  padding: 0 10px;\n}\n.reminder-timing {\n  display: grid;\n  grid-template-columns: 80px 100px 1fr;\n  align-items: center;\n  gap: 8px;\n}\n.reminder-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  min-height: 40px;\n  padding: 4px 8px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n}\n.reminder-toolbar select {\n  height: 30px;\n}\n.reminder-edit-card textarea {\n  min-height: 160px;\n  resize: vertical;\n  padding: 10px;\n}\n.reminder-edit-card footer,\n.payment-edit-card footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.reminder-email-preview {\n  max-width: 720px;\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n}\n.reminder-email-preview article {\n  margin-top: 12px;\n  color: var(--text-primary, #142624);\n  background: var(--surface-primary, #fff);\n}\n.payment-details-card,\n.payment-edit-card {\n  max-width: 1120px;\n}\n.payment-success {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n  border-radius: 14px;\n  padding: 16px;\n  background: var(--success-soft, #eaf8ef);\n  color: var(--success-text, #167044);\n}\n.payment-success p {\n  margin: 4px 0 0;\n  color: inherit;\n}\n.payment-values {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  padding: 16px;\n}\n.payment-values span {\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n}\n.payment-values strong {\n  margin-bottom: 4px;\n  font-size: 14px;\n}\n.payment-edit-card {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.payment-edit-card label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.payment-edit-card label b {\n  color: var(--danger-text, #a3301f);\n}\n.payment-required-label {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 3px;\n}\n.payment-edit-card label small {\n  min-height: 16px;\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 15.4px;\n}\n.payment-edit-card label.error input {\n  border-color: var(--danger-default, #c23a2b);\n}\n.payment-edit-card label.error small,\n.payment-form-error {\n  color: var(--danger-text, #a3301f);\n}\n.payment-form-error {\n  margin: 0;\n  font-size: 12px;\n}\n.payment-edit-card > div {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n@media (max-width: 640px) {\n  .settings-reminder-heading {\n    gap: 12px;\n  }\n  .settings-reminder-heading > div {\n    min-width: 0;\n  }\n  .settings-reminder-heading .settings-switch {\n    flex: 0 0 auto;\n    margin-top: 2px;\n  }\n  .reminder-list {\n    padding: 10px 16px;\n  }\n  .reminder-row {\n    grid-template-columns: 40px 1fr 32px 32px;\n    gap: 8px;\n    min-height: 90px;\n  }\n  .reminder-row button {\n    width: 32px;\n    height: 32px;\n  }\n  .settings-sheet-scrim {\n    align-items: flex-end;\n    justify-content: stretch;\n  }\n  .settings-sheet {\n    width: 100%;\n    max-height: calc(100dvh - 16px);\n    overscroll-behavior: contain;\n    border-radius: 20px 20px 0 0;\n    padding: 8px 16px calc(16px + env(safe-area-inset-bottom));\n  }\n  .settings-sheet-handle {\n    display: block;\n    width: 40px;\n    height: 4px;\n    margin: 0 auto 14px;\n    border-radius: 999px;\n    background: var(--border-default, #cdd6d4);\n  }\n  .settings-sheet header {\n    margin-inline: -16px;\n    padding: 0 16px 16px;\n  }\n  .settings-sheet header p {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n  .reminder-preview article {\n    padding: 16px;\n  }\n  .reminder-edit-card {\n    padding: 12px;\n  }\n  .reminder-timing {\n    grid-template-columns: 76px 76px 1fr;\n  }\n  .reminder-edit-card footer {\n    justify-content: flex-end;\n  }\n  .payment-edit-card > div {\n    grid-template-columns: 1fr;\n  }\n  .settings-payment-heading {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 8px 12px;\n  }\n  .settings-payment-heading > div {\n    display: contents;\n  }\n  .settings-payment-heading h2 {\n    grid-area: 1 / 1;\n    align-self: center;\n  }\n  .settings-payment-heading p {\n    grid-area: 2 / 1 / 3 / -1;\n  }\n  .settings-payment-heading > .settings-button {\n    grid-area: 1 / 2;\n    height: 36px;\n    min-height: 36px;\n    align-self: center;\n    gap: 6px;\n    padding: 0 12px;\n    font-size: 13px;\n  }\n  .payment-details-card {\n    min-height: 399px;\n    padding: 16px;\n  }\n  .payment-success {\n    min-height: 89px;\n    margin-bottom: 20px;\n    padding: 16px;\n  }\n  .payment-values {\n    min-height: 208px;\n    padding: 16px;\n  }\n  .payment-details-card > p {\n    margin: 20px 0 0;\n    font-size: 11px;\n    line-height: 15.4px;\n  }\n  .payment-empty-card {\n    min-height: 326px;\n    padding: 48px 32px;\n  }\n  .settings-payment-edit-heading {\n    margin-bottom: 16px;\n  }\n  .payment-edit-card {\n    gap: 12px;\n    margin-bottom: 0;\n    padding: 16px;\n  }\n  .payment-edit-card input {\n    border-radius: 10px;\n  }\n  .payment-edit-card footer {\n    gap: 12px;\n    margin-top: 12px;\n  }\n  .payment-edit-card footer .settings-button {\n    height: 40px;\n    min-height: 40px;\n  }\n  .settings-heading-action {\n    align-items: flex-start;\n  }\n  .settings-heading-action > .settings-button {\n    align-self: flex-end;\n  }\n  .settings-team-workspace > .settings-heading-action {\n    gap: 12px;\n  }\n  .settings-team-workspace > .settings-heading-action > .settings-button {\n    width: 100%;\n    min-height: 40px;\n    align-self: stretch;\n  }\n  .settings-team-workspace > .settings-team-tabs {\n    width: 100%;\n    margin: 16px 0 20px;\n  }\n  .settings-team-workspace > .settings-team-tabs button {\n    min-height: 41px;\n    padding-inline: 16px;\n  }\n  .settings-team-stats {\n    gap: 8px;\n    margin-bottom: 20px;\n  }\n  .settings-team-stats section {\n    min-height: 103px;\n    padding: 16px 20px;\n  }\n  .settings-team-stats span {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n  .settings-team-stats strong {\n    margin: 3px 0 1px;\n    font-size: 20px;\n    line-height: 26px;\n  }\n  .settings-team-stats small {\n    font-size: 11px;\n    line-height: 15.4px;\n  }\n}\n\n/* Plan & billing — Figma section 1926:167062 */\n.plan-billing-workspace {\n  width: 100%;\n}\n.plan-billing-workspace button,\n.plan-billing-workspace input,\n.plan-billing-workspace select {\n  font-family: inherit;\n}\n.plan-billing-heading {\n  position: relative;\n}\n.plan-billing-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 12px;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--text-link, var(--interactive-default));\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.plan-billing-back svg {\n  width: 16px;\n  height: 16px;\n}\n.plan-billing-button {\n  display: inline-flex;\n  height: 44px;\n  min-height: 44px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 16px;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: normal;\n  letter-spacing: 0;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.plan-billing-button.primary {\n  color: var(--on-interactive-primary, #fff);\n  background: var(--interactive-default, #0f766e);\n}\n.plan-billing-button.secondary {\n  color: var(--text-primary);\n  border-color: var(--border-default);\n  background: var(--surface-primary);\n}\n.plan-billing-button.primary:hover:not(:disabled) {\n  border-color: var(--interactive-hover, var(--interactive-default));\n  background: var(--interactive-hover, var(--interactive-default));\n}\n.plan-billing-button.secondary:hover:not(:disabled) {\n  border-color: var(--border-strong, var(--border-default));\n  background: var(--surface-secondary);\n}\n.plan-billing-button:disabled {\n  color: var(--text-disabled, #8a9896);\n  border-color: var(--border-subtle);\n  background: var(--surface-secondary);\n  cursor: not-allowed;\n}\n.plan-current-card,\n.plan-usage-grid > section,\n.plan-navigation-grid > section,\n.plan-summary-grid > section,\n.billing-status-grid > section,\n.billing-contact-card,\n.billing-payment-card,\n.add-card-panel,\n.payment-saved-panel,\n.available-plan-grid > section {\n  border: 1px solid var(--border-default);\n  border-radius: 14px;\n  background: var(--surface-primary);\n}\n.plan-current-card {\n  display: flex;\n  min-height: 180px;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 16px;\n  padding: 20px 28px;\n}\n.plan-current-card > div {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 8px;\n}\n.plan-current-card small,\n.billing-status-grid small,\n.available-plan-grid small {\n  color: var(--interactive-default);\n  font-size: 11px;\n  line-height: 14.3px;\n  font-weight: 600;\n  letter-spacing: 0.88px;\n}\n.plan-current-card h3 {\n  margin: 0;\n  font-size: 28px;\n  line-height: 36.4px;\n  font-weight: 600;\n  letter-spacing: -0.28px;\n}\n.plan-current-card strong {\n  font: 400 16px/25.6px var(--font-family-mono, monospace);\n}\n.plan-current-card span,\n.plan-current-card p {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.plan-current-card p {\n  color: var(--text-primary);\n  font-size: 16px;\n  line-height: 25.6px;\n}\n.plan-usage-grid,\n.plan-navigation-grid,\n.plan-summary-grid,\n.billing-status-grid,\n.available-plan-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n.plan-usage-grid > section {\n  display: flex;\n  min-height: 184px;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n}\n.plan-usage-grid svg {\n  width: 20px;\n  height: 20px;\n  color: var(--interactive-default);\n}\n.plan-usage-grid span {\n  font-size: 14px;\n  line-height: 18.2px;\n  font-weight: 500;\n}\n.plan-usage-grid strong {\n  font-size: 28px;\n  line-height: 36.4px;\n  font-weight: 600;\n  letter-spacing: -0.28px;\n}\n.plan-usage-grid p {\n  flex: 1;\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.plan-usage-grid button,\n.plan-navigation-grid button,\n.available-plan-heading button {\n  width: fit-content;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--text-link, var(--interactive-default));\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.plan-navigation-grid > section {\n  display: flex;\n  min-height: 160px;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n}\n.plan-navigation-grid h3,\n.available-plan-heading h3 {\n  margin: 0;\n  font-size: 18px;\n  line-height: 25.2px;\n  font-weight: 500;\n  letter-spacing: -0.09px;\n}\n.plan-navigation-grid p {\n  flex: 1;\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.plan-navigation-grid button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.plan-summary-grid {\n  grid-template-columns: 1fr 1fr 0.7fr;\n}\n.plan-summary-grid > section {\n  display: flex;\n  min-height: 112px;\n  flex-direction: column;\n  gap: 6px;\n  padding: 16px;\n}\n.plan-summary-grid span {\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n.plan-summary-grid strong {\n  font-size: 20px;\n  font-weight: 500;\n}\n.plan-summary-grid small {\n  color: var(--text-secondary);\n  font-size: 12px;\n}\n.plan-history-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 10px 0 16px;\n}\n.plan-history-toolbar > div {\n  display: flex;\n  gap: 10px;\n}\n.plan-history-toolbar select {\n  min-width: 120px;\n  height: 44px;\n  padding: 0 30px 0 12px;\n  border: 1px solid var(--border-default);\n  border-radius: 10px;\n  color: var(--text-primary);\n  background: var(--surface-primary);\n}\n.plan-history-table-wrap {\n  overflow: hidden;\n  border: 1px solid var(--border-default);\n  border-radius: 14px;\n  background: var(--surface-primary);\n}\n.plan-history-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.plan-history-table th,\n.plan-history-table td {\n  height: 52px;\n  padding: 0 16px;\n  border-bottom: 1px solid var(--border-subtle);\n  text-align: left;\n  font-size: 13px;\n  font-weight: 400;\n}\n.plan-history-table th {\n  height: 44px;\n  color: var(--text-secondary);\n  background: var(--surface-secondary);\n  font-weight: 500;\n}\n.plan-history-table td:first-child {\n  color: var(--text-link);\n  font-family: var(--font-family-mono, monospace);\n}\n.plan-history-table td > span {\n  padding: 5px 8px;\n  border-radius: 999px;\n  color: var(--success-text);\n  background: var(--success-soft);\n  font-size: 11px;\n}\n.plan-history-table td button {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--text-link);\n  text-decoration: underline;\n  cursor: pointer;\n}\n.plan-history-table-wrap > footer {\n  display: flex;\n  min-height: 52px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  color: var(--text-secondary);\n  font-size: 12px;\n}\n.plan-history-table-wrap footer div {\n  display: flex;\n  gap: 8px;\n}\n.plan-history-table-wrap footer button {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  place-items: center;\n  border: 1px solid var(--border-subtle);\n  border-radius: 8px;\n  color: var(--text-secondary);\n  background: transparent;\n}\n.credit-management-summary {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n.credit-management-summary > section,\n.credit-topup-card,\n.credit-usage-card {\n  border: 1px solid var(--border-default);\n  border-radius: 14px;\n  background: var(--surface-primary);\n}\n.credit-management-summary > section {\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  gap: 5px 12px;\n  padding: 18px 20px;\n}\n.credit-management-summary svg {\n  grid-row: 1 / span 3;\n  width: 22px;\n  height: 22px;\n  color: var(--interactive-default);\n}\n.credit-management-summary span,\n.credit-management-summary small {\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n.credit-management-summary strong {\n  font-size: 22px;\n  line-height: 29px;\n  font-weight: 600;\n}\n.credit-management-summary .app-skeleton {\n  max-width: 100%;\n}\n.credit-topup-card {\n  margin-bottom: 16px;\n  padding: 20px;\n}\n.credit-topup-card h3,\n.credit-usage-card h3 {\n  margin: 0 0 5px;\n  font-size: 18px;\n  line-height: 25px;\n  font-weight: 500;\n}\n.credit-topup-card p,\n.credit-usage-card p {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 13px;\n  line-height: 20px;\n}\n.credit-topup-fields {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  margin-top: 18px;\n}\n.credit-topup-fields label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  color: var(--text-primary);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: normal;\n}\n.credit-topup-fields label b {\n  color: var(--danger-text);\n}\n.credit-topup-fields input,\n.credit-usage-search {\n  height: 42px;\n  box-sizing: border-box;\n  border: 1px solid var(--border-default);\n  border-radius: 10px;\n  color: var(--text-primary);\n  background: var(--surface-primary);\n}\n.credit-topup-fields input {\n  height: 32px;\n  padding: 0 10px;\n  outline: 0;\n  font: 400 13px / normal var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.credit-topup-fields input:focus {\n  border: 2px solid var(--interactive-default);\n  padding: 0 9px;\n  box-shadow: 0 0 0 3px rgba(15, 186, 196, 0.22);\n}\n.credit-topup-fields label.has-error input {\n  border-color: var(--danger-default, #c23a2b);\n  box-shadow: none;\n}\n.credit-topup-fields input[readonly] {\n  border-color: var(--border-subtle);\n  color: var(--text-disabled, #8a9896);\n  background: var(--surface-secondary);\n  opacity: 0.75;\n}\n.credit-topup-fields small {\n  min-height: 14px;\n  color: var(--text-secondary);\n  font-size: 11px;\n  font-weight: 400;\n  line-height: normal;\n}\n.credit-topup-fields label.has-error small {\n  color: var(--danger-default, #c23a2b);\n}\n.credit-topup-card footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 18px;\n}\n.plan-billing-button.primary.credit-topup-submit[aria-busy=\"true\"] {\n  border-color: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n  background: var(--interactive-default, #0f766e);\n  opacity: 1;\n  cursor: wait;\n}\n.credit-topup-submit {\n  width: 120px;\n  min-width: 120px;\n  height: 40px;\n  min-height: 40px;\n  gap: 8px;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: normal;\n}\n.credit-topup-submit .credit-topup-spinner {\n  color: currentColor;\n}\n.credit-payment-link {\n  border: 0;\n  background: transparent;\n  color: var(--text-link);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.credit-topup-card .credit-management-message {\n  margin-top: 12px;\n  color: var(--text-primary);\n}\n.credit-usage-card {\n  overflow: hidden;\n}\n.credit-usage-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  padding: 20px;\n}\n.credit-usage-search {\n  display: flex;\n  width: min(100%, 320px);\n  align-items: center;\n  gap: 8px;\n  padding: 0 6px 0 12px;\n}\n.credit-usage-search > svg {\n  width: 17px;\n  height: 17px;\n  flex: 0 0 17px;\n  color: var(--text-secondary);\n}\n.credit-usage-search:hover {\n  border-color: var(--border-strong, #aebab8);\n}\n.credit-usage-search:focus-within {\n  border-color: var(--interactive-default, #0f766e);\n}\n.credit-usage-search input {\n  min-width: 0;\n  flex: 1;\n  border: 0;\n  outline: 0;\n  padding: 0;\n  color: var(--text-primary);\n  background: transparent;\n  font: 400 14px / normal var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.credit-usage-search input::placeholder {\n  color: var(--text-secondary);\n}\n.credit-usage-table-wrap {\n  overflow-x: auto;\n}\n.credit-usage-table {\n  width: 100%;\n  min-width: 720px;\n  border-collapse: collapse;\n}\n.credit-usage-table th,\n.credit-usage-table td {\n  height: 52px;\n  padding: 0 16px;\n  border-top: 1px solid var(--border-subtle);\n  text-align: left;\n  font-size: 13px;\n  font-weight: 400;\n}\n.credit-usage-table th {\n  height: 44px;\n  color: var(--text-secondary);\n  background: var(--surface-secondary);\n  font-weight: 500;\n}\n.credit-usage-table th:nth-child(n + 3),\n.credit-usage-table td:nth-child(n + 3) {\n  text-align: right;\n  font-family: var(--font-family-mono, monospace);\n}\n.credit-usage-table td[colspan] {\n  color: var(--text-secondary);\n  text-align: center;\n  font-family: inherit;\n}\n.credit-usage-skeleton-row .app-skeleton {\n  max-width: 100%;\n}\n.credit-usage-skeleton-row td:nth-child(n + 3) .app-skeleton {\n  margin-left: auto;\n}\n.credit-usage-filler-row td {\n  color: transparent;\n  user-select: none;\n}\n.credit-usage-empty-row {\n  height: 520px;\n}\n.credit-usage-table .credit-positive {\n  color: var(--success-text);\n}\n.credit-usage-card > footer {\n  display: flex;\n  min-height: 54px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  border-top: 1px solid var(--border-subtle);\n  padding: 0 16px;\n  color: var(--text-secondary);\n  font-size: 12px;\n}\n.credit-usage-card > footer > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.credit-usage-card > footer button {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  place-items: center;\n  border: 1px solid var(--border-subtle);\n  border-radius: 8px;\n  color: var(--text-secondary);\n  background: transparent;\n  cursor: pointer;\n}\n.credit-usage-card > footer button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.billing-status-grid {\n  grid-template-columns: 1fr 1fr;\n}\n.billing-status-grid > section {\n  display: flex;\n  min-height: 118px;\n  flex-direction: column;\n  gap: 8px;\n  padding: 20px;\n}\n.billing-status-grid strong {\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 500;\n}\n.billing-status-grid span {\n  font-size: 14px;\n}\n.billing-contact-card,\n.billing-payment-card,\n.add-card-panel {\n  position: relative;\n  margin-bottom: 16px;\n  padding: 24px;\n}\n.billing-contact-card h3,\n.billing-payment-card h3,\n.add-card-panel h3,\n.payment-saved-panel h3 {\n  margin: 0 0 8px;\n  font-size: 22px;\n  line-height: 29.7px;\n  font-weight: 500;\n  letter-spacing: -0.22px;\n}\n.billing-contact-card > p,\n.billing-payment-card p {\n  margin: 0 0 16px;\n  color: var(--text-secondary);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.billing-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px 16px;\n}\n.billing-form-grid label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 500;\n}\n.billing-form-grid label b {\n  color: var(--danger-text);\n}\n.billing-required-label {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 3px;\n}\n.billing-form-grid input {\n  width: 100%;\n  height: 42px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default);\n  border-radius: 8px;\n  outline: none;\n  color: var(--text-primary);\n  background: var(--surface-primary);\n  font-size: 14px;\n}\n.billing-form-grid input:focus {\n  border-color: var(--interactive-default);\n  box-shadow: none;\n}\n.billing-form-grid input.error {\n  border-color: var(--danger-default);\n}\n.billing-form-grid small {\n  min-height: 17px;\n  color: var(--text-secondary);\n  font-size: 11px;\n  font-weight: 400;\n}\n.billing-form-grid input.error + small {\n  color: var(--danger-text);\n}\n.billing-payment-card {\n  min-height: 140px;\n}\n.billing-payment-card > .plan-billing-button {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n.billing-saved-card {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  margin-top: 18px;\n}\n.billing-saved-card > div:last-child p {\n  margin: 5px 0;\n}\n.billing-saved-card em,\n.payment-saved-panel em {\n  margin-left: 6px;\n  padding: 4px 8px;\n  border-radius: 999px;\n  color: var(--interactive-default);\n  background: var(--interactive-soft);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n}\n.plan-card-visual {\n  position: relative;\n  display: grid;\n  width: 300px;\n  height: 160px;\n  flex: 0 0 auto;\n  grid-template-columns: 1fr 1fr;\n  align-content: space-between;\n  padding: 20px;\n  border-radius: 14px;\n  color: #fff;\n  background: linear-gradient(120deg, #0d8ea0, #06343b);\n  box-shadow: inset 0 0 38px rgba(0, 0, 0, 0.16);\n}\n.plan-card-visual > b {\n  grid-column: 1 / -1;\n  font-size: 12px;\n}\n.plan-card-visual > i {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 34px;\n  height: 25px;\n  border-radius: 5px;\n  background: #e9a020;\n}\n.plan-card-visual > strong {\n  grid-column: 1 / -1;\n  font: 500 14px/20px var(--font-family-mono, monospace);\n}\n.plan-card-visual > span {\n  font-size: 9px;\n  line-height: 16px;\n}\n.plan-card-visual > span:last-child {\n  text-align: right;\n}\n.billing-footer-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 16px;\n}\n.add-card-panel {\n  padding: 24px;\n}\n.payment-security-copy {\n  color: var(--text-secondary);\n  font-size: 13px;\n  line-height: 20px;\n}\n.payment-saved-panel {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding: 24px;\n}\n.payment-saved-panel > div:last-child {\n  flex: 1;\n}\n.payment-saved-panel p {\n  max-width: 620px;\n  color: var(--text-secondary);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.available-plan-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin: 10px 0 16px;\n}\n.available-plan-heading p,\n.plan-comparison > p {\n  margin: 4px 0 0;\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n.available-plan-grid > section {\n  display: flex;\n  min-height: 360px;\n  flex-direction: column;\n  padding: 16px;\n}\n.available-plan-grid > section.current {\n  border: 2px solid var(--interactive-default);\n  padding: 15px;\n}\n.available-plan-grid h3 {\n  margin: 0 0 8px;\n  font-size: 24px;\n  line-height: 31px;\n  font-weight: 600;\n}\n.available-plan-grid p {\n  color: var(--text-secondary);\n  font-size: 13px;\n  line-height: 20px;\n}\n.available-plan-grid > section > strong {\n  font: 400 14px/22px var(--font-family-mono, monospace);\n}\n.available-plan-grid hr {\n  width: 100%;\n  margin: 10px 0;\n  border: 0;\n  border-top: 1px solid var(--border-subtle);\n}\n.available-plan-grid ul {\n  flex: 1;\n  margin: 10px 0 16px;\n  padding: 0;\n  list-style: none;\n}\n.available-plan-grid li {\n  display: flex;\n  gap: 7px;\n  margin: 9px 0;\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n.available-plan-grid li svg {\n  flex: 0 0 auto;\n}\n.plan-comparison {\n  margin: 28px 16px 0;\n}\n.plan-comparison h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n}\n.plan-comparison > div {\n  overflow-x: auto;\n  margin-top: 12px;\n  border: 1px solid var(--border-default);\n  border-radius: 12px;\n}\n.plan-comparison table {\n  width: 100%;\n  min-width: 720px;\n  border-collapse: collapse;\n}\n.plan-comparison th,\n.plan-comparison td {\n  height: 44px;\n  padding: 0 16px;\n  border-bottom: 1px solid var(--border-subtle);\n  text-align: left;\n  font-size: 12px;\n  font-weight: 400;\n}\n.plan-comparison th {\n  background: var(--surface-secondary);\n  font-weight: 500;\n}\n.plan-comparison tr:nth-child(even) {\n  background: var(--surface-secondary);\n}\n.plan-modal-backdrop {\n  position: fixed;\n  z-index: 1600;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  padding: 20px;\n  background: var(--overlay-default, rgba(15, 29, 27, 0.48));\n}\n.plan-modal {\n  width: min(520px, 100%);\n  overflow: hidden;\n  border: 1px solid var(--border-subtle);\n  border-radius: 20px;\n  color: var(--text-primary);\n  background: var(--surface-elevated, var(--surface-primary));\n  box-shadow: 0 6px 8px rgba(14, 26, 32, 0.1), 0 1px 1px rgba(14, 26, 32, 0.04);\n}\n.plan-modal header {\n  display: flex;\n  min-height: 73px;\n  gap: 12px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 28px 28px 20px;\n  border-bottom: 1px solid var(--border-subtle);\n}\n.plan-modal h3 {\n  flex: 1;\n  margin: 0;\n  font-size: 16px;\n  line-height: 22.4px;\n  font-weight: 500;\n  letter-spacing: -0.08px;\n}\n.plan-modal-title-icon {\n  width: 24px;\n  height: 24px;\n  flex: 0 0 24px;\n  color: var(--danger-default, #c23a2b);\n  stroke-width: 1.75;\n}\n.plan-modal header button {\n  display: grid;\n  place-items: center;\n  padding: 5px;\n  border: 0;\n  color: var(--text-secondary);\n  background: none;\n  cursor: pointer;\n}\n.plan-modal header button svg {\n  width: 20px;\n  height: 20px;\n  stroke-width: 1.75;\n}\n.plan-modal > div {\n  padding: 20px 28px 12px;\n}\n.plan-modal.subscription-modal--confirm > div {\n  padding: 24px 28px 0;\n}\n.plan-modal p {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 13px;\n  line-height: 20.2px;\n}\n.plan-modal footer {\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  justify-content: flex-end;\n  gap: 12px;\n  min-height: auto;\n  padding: 28px !important;\n}\n.plan-modal.subscription-modal--confirm footer {\n  min-height: auto;\n  padding: 28px !important;\n}\n.plan-modal footer .plan-billing-button {\n  height: 40px;\n  min-height: 40px;\n  padding: 0 12px;\n  font-size: 13px;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n}\n.plan-cancel-link {\n  min-height: 40px;\n  padding: 0 16px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--danger-default, #c23a2b) !important;\n  -webkit-text-fill-color: var(--danger-default, #c23a2b);\n  font: 500 13px/16.9px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0.065px;\n  cursor: pointer;\n}\n\n@media (max-width: 900px) {\n  .plan-usage-grid,\n  .available-plan-grid {\n    grid-template-columns: 1fr;\n  }\n  .plan-usage-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n  .plan-navigation-grid {\n    grid-template-columns: 1fr;\n  }\n  .plan-summary-grid {\n    grid-template-columns: repeat(3, minmax(190px, 1fr));\n    overflow-x: auto;\n  }\n  .plan-history-table-wrap {\n    overflow-x: auto;\n  }\n  .plan-history-table {\n    min-width: 850px;\n  }\n  .billing-saved-card,\n  .payment-saved-panel {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n@media (max-width: 640px) {\n  .plan-billing-button {\n    height: 40px;\n    min-height: 40px;\n    gap: 6px;\n    padding: 0 12px;\n    font-size: 13px;\n  }\n  .plan-usage-grid {\n    grid-template-columns: 1fr;\n  }\n  .plan-current-card,\n  .available-plan-heading {\n    flex-direction: column;\n  }\n  .billing-status-grid,\n  .billing-form-grid,\n  .credit-management-summary,\n  .credit-topup-fields {\n    grid-template-columns: 1fr;\n  }\n  .credit-usage-heading {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .credit-usage-search {\n    width: 100%;\n  }\n  .credit-topup-card footer {\n    align-items: stretch;\n    flex-direction: column-reverse;\n  }\n  .credit-topup-card footer .plan-billing-button {\n    width: 100%;\n  }\n  .credit-usage-card > footer {\n    align-items: flex-start;\n    flex-direction: column;\n    padding-block: 12px;\n  }\n  .plan-history-toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 12px;\n  }\n  .plan-history-toolbar > div {\n    width: 100%;\n  }\n  .plan-history-toolbar select,\n  .plan-history-toolbar .plan-billing-button {\n    flex: 1;\n  }\n  .billing-payment-card {\n    padding-top: 78px;\n  }\n  .billing-payment-card > .plan-billing-button {\n    right: 16px;\n    left: 16px;\n  }\n  .plan-card-visual {\n    width: 100%;\n    max-width: 300px;\n  }\n  .billing-footer-actions,\n  .plan-modal footer {\n    flex-wrap: wrap;\n  }\n  .plan-modal-backdrop {\n    align-items: end;\n    padding: 0;\n  }\n  .plan-modal.subscription-modal {\n    width: 100%;\n    max-height: calc(100dvh - 16px);\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    border-radius: 20px 20px 0 0;\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n  .plan-modal.subscription-modal footer {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n  }\n  .plan-modal.subscription-modal footer .plan-billing-button {\n    width: auto;\n  }\n}\n\n@media (max-width: 640px) {\n  .settings-profile-fields {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  .settings-profile-fields .wide {\n    grid-column: auto;\n  }\n  .settings-photo-actions {\n    justify-content: center;\n  }\n  .settings-photo-actions .settings-button {\n    min-width: 118px;\n  }\n  .settings-role-row {\n    align-items: flex-start;\n  }\n  .settings-role-row p {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n  .settings-personal-card .settings-card-actions .settings-button,\n  .settings-security-card > .settings-button,\n  .settings-password-actions .settings-button {\n    height: 40px;\n    min-height: 40px;\n  }\n  .settings-personal-card .settings-card-actions .settings-button {\n    width: auto;\n    height: 40px;\n    min-height: 40px;\n    flex: 0 0 auto;\n    gap: 6px;\n    border-radius: var(--radius-md, 10px);\n    padding: 0 12px;\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 13px;\n    font-weight: var(--font-weight-medium, 500);\n    line-height: normal;\n    letter-spacing: 0;\n    cursor: pointer;\n  }\n  .settings-personal-card .settings-card-actions .settings-button:disabled {\n    cursor: default;\n    opacity: 0.65;\n  }\n  .settings-photo-dialog-scrim {\n    align-items: end;\n    padding: 0;\n  }\n  .settings-photo-dialog {\n    width: 100%;\n    height: 427px;\n    max-height: calc(100vh - 16px);\n    max-height: calc(100dvh - 16px);\n    min-height: 0;\n    overflow: hidden;\n    overscroll-behavior: contain;\n    gap: 16px;\n    border-radius: 20px 20px 0 0;\n    padding: 16px;\n    box-shadow: 0 1px 2px rgba(14, 26, 32, 0.04),\n      0 6px 16px -4px rgba(14, 26, 32, 0.1);\n  }\n  .settings-photo-dialog-body {\n    scrollbar-width: none;\n    touch-action: pan-y;\n  }\n  .settings-photo-dialog-body::-webkit-scrollbar {\n    display: none;\n  }\n  .settings-photo-dialog h2 {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n  }\n  .settings-photo-dialog header button {\n    width: auto;\n    height: 30px;\n    padding: 0;\n    color: var(--interactive-default, #0f766e);\n    font: 500 13px / 16.9px var(--font-family-primary, \"Lexend\", sans-serif);\n  }\n  .settings-photo-dialog header button svg {\n    display: none;\n  }\n  .settings-photo-dialog header button span {\n    display: inline;\n  }\n  .settings-photo-dialog-body > p {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n  .settings-photo-dialog-preview {\n    width: 100%;\n    height: 210px;\n    min-height: 210px;\n    flex: 0 0 210px;\n    padding: 20px 16px;\n  }\n  .settings-photo-dialog-preview .settings-avatar {\n    width: 88px;\n    height: 88px;\n    border-width: 2px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .settings-photo-dialog-preview strong {\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 24px;\n  }\n  .settings-photo-dialog-preview small,\n  .settings-photo-dialog-note {\n    font-size: 11px;\n    line-height: 15.4px;\n    letter-spacing: 0.11px;\n  }\n  .settings-photo-dialog .settings-photo-choose {\n    width: 100%;\n    height: 44px;\n    min-height: 44px;\n    flex: 0 0 44px;\n    padding: 0 16px;\n    font-size: 14px;\n    line-height: normal;\n  }\n  .settings-photo-dialog-actions .settings-button {\n    width: auto;\n    height: 44px;\n    min-height: 44px;\n    flex: 1 1 0;\n    padding: 0 16px;\n    font-size: 14px;\n    line-height: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
